import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../styles/icons/logo.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

const Patch = ({ color, className }) => (
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        width="470px"
        height="420px"
        viewBox="0 0 470 420"
        className={classNames([styles.container, { [className]: className !== null }])}
        xmlSpace="preserve"
    >
        <g>
            <path fill={color} d="M190,3.7c-0.1-0.1-0.3-0.2-0.5-0.5C189.4,3.7,189.5,3.8,190,3.7z" />
            <path
                fill={color}
                d="M213.7,3.4c0.7,0.2,0.8-0.1,1.1-0.4C214.2,2.8,213.9,3.1,213.7,3.4z"
            />
            <path
                fill={color}
                d="M124.9,3.9c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.3,0,0.3-0.1c0-0.1,0-0.2-0.1-0.4C125,3.8,124.9,3.8,124.9,3.9z"
            />
            <path
                fill={color}
                d="M123.4,3.6c0.2-0.2,0.4-0.3,0.6-0.5C123.2,3.2,123.2,3.2,123.4,3.6z"
            />
            <path
                fill={color}
                d="M119.9,3.8c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.4c-0.1,0-0.2,0-0.3,0C119.8,3.6,119.8,3.7,119.9,3.8z"
            />
            <path
                fill={color}
                d="M115.2,3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2C115.4,2.8,115.3,2.9,115.2,3z"
            />
            <path
                fill={color}
                d="M137.7,2.9c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.2-0.3-0.2
        		C137.8,2.8,137.7,2.8,137.7,2.9z"
            />
            <path
                fill={color}
                d="M143.6,3.9c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.1-0.1,0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.2
        		C143.7,3.8,143.5,3.8,143.6,3.9z"
            />
            <path
                fill={color}
                d="M150.1,5.1c0,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.3-0.1c0-0.1-0.1-0.2-0.3-0.4C150.2,5,150.1,5.1,150.1,5.1z"
            />
            <path
                fill={color}
                d="M135.9,4.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0-0.1-0.1-0.2-0.1-0.3C136,4,135.9,4.1,135.9,4.1z"
            />
            <path
                fill={color}
                d="M134.4,3.7c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.3c0.1-0.1,0.2-0.2,0.2-0.3
        		C134.6,3.8,134.5,3.8,134.4,3.7z"
            />
            <path
                fill={color}
                d="M137.3,5.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2
        		C137.5,5.1,137.4,5.1,137.3,5.2z"
            />
            <path
                fill={color}
                d="M369.4,3.7c-0.1-0.1-0.3-0.2-0.5-0.5C368.8,3.7,368.9,3.8,369.4,3.7z"
            />
            <path
                fill={color}
                d="M393.1,3.4c0.7,0.2,0.8-0.1,1.1-0.4C393.5,2.8,393.3,3.1,393.1,3.4z"
            />
            <path
                fill={color}
                d="M304.3,3.9c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.3,0,0.3-0.1c0-0.1,0-0.2-0.1-0.4C304.4,3.8,304.3,3.8,304.3,3.9z"
            />
            <path
                fill={color}
                d="M302.8,3.6c0.2-0.2,0.4-0.3,0.6-0.5C302.6,3.2,302.6,3.2,302.8,3.6z"
            />
            <path
                fill={color}
                d="M299.3,3.8c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.4c-0.1,0-0.2,0-0.3,0C299.2,3.6,299.2,3.7,299.3,3.8z"
            />
            <path
                fill={color}
                d="M294.6,3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2C294.7,2.8,294.7,2.9,294.6,3z"
            />
            <path
                fill={color}
                d="M317,2.9c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.2-0.3-0.2
        		C317.2,2.8,317.1,2.8,317,2.9z"
            />
            <path
                fill={color}
                d="M322.9,3.9c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.1-0.1,0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.2
        		C323.1,3.8,322.9,3.8,322.9,3.9z"
            />
            <path
                fill={color}
                d="M329.5,5.1c0,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.3-0.1c0-0.1-0.1-0.2-0.3-0.4C329.6,5,329.4,5.1,329.5,5.1z"
            />
            <path
                fill={color}
                d="M315.3,4.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0-0.1-0.1-0.2-0.1-0.3C315.4,4,315.3,4.1,315.3,4.1z"
            />
            <path
                fill={color}
                d="M313.8,3.7c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.3C313.9,4,314,4,314,3.9
        		C314,3.8,313.9,3.8,313.8,3.7z"
            />
            <path
                fill={color}
                d="M316.7,5.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2
        		C316.8,5.1,316.8,5.1,316.7,5.2z"
            />
            <path fill={color} d="M84.6,3.7c-0.1-0.1-0.3-0.2-0.5-0.5C84,3.7,84.1,3.8,84.6,3.7z" />
            <path
                fill={color}
                d="M108.3,3.4c0.7,0.2,0.8-0.1,1.1-0.4C108.7,2.8,108.5,3.1,108.3,3.4z"
            />
            <path
                fill={color}
                d="M19.5,3.9c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.3,0,0.3-0.1c0-0.1,0-0.2-0.1-0.4C19.6,3.8,19.5,3.8,19.5,3.9z"
            />
            <path fill={color} d="M18,3.6c0.2-0.2,0.4-0.3,0.6-0.5C17.8,3.2,17.8,3.2,18,3.6z" />
            <path
                fill={color}
                d="M14.5,3.8c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.4c-0.1,0-0.2,0-0.3,0C14.4,3.6,14.4,3.7,14.5,3.8z"
            />
            <path
                fill={color}
                d="M9.8,3c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2C9.9,2.8,9.9,2.9,9.8,3z"
            />
            <path
                fill={color}
                d="M32.2,2.9C32.4,2.9,32.5,3,32.6,3c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.2-0.3-0.2C32.4,2.8,32.3,2.8,32.2,2.9
        		z"
            />
            <path
                fill={color}
                d="M38.1,3.9c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.1-0.1,0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.2
        		C38.3,3.8,38.1,3.8,38.1,3.9z"
            />
            <path
                fill={color}
                d="M44.7,5.1c0,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.3-0.1c0-0.1-0.1-0.2-0.3-0.4C44.8,5,44.6,5.1,44.7,5.1z"
            />
            <path
                fill={color}
                d="M30.5,4.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0-0.1-0.1-0.2-0.1-0.3C30.6,4,30.5,4.1,30.5,4.1z"
            />
            <path
                fill={color}
                d="M29,3.7c-0.1,0.1-0.2,0.1-0.2,0.2C28.8,4,28.9,4,29,4.2C29.1,4,29.2,4,29.2,3.9C29.2,3.8,29.1,3.8,29,3.7z"
            />
            <path
                fill={color}
                d="M31.9,5.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2C32,5.1,32,5.1,31.9,5.2z"
            />
            <path fill={color} d="M264,3.7c-0.1-0.1-0.3-0.2-0.5-0.5C263.4,3.7,263.5,3.8,264,3.7z" />
            <path
                fill={color}
                d="M287.7,3.4c0.7,0.2,0.8-0.1,1.1-0.4C288.1,2.8,287.9,3.1,287.7,3.4z"
            />
            <path
                fill={color}
                d="M198.8,3.9c0,0.1,0.1,0.2,0.1,0.2c0.1,0,0.3,0,0.3-0.1c0-0.1,0-0.2-0.1-0.4C199,3.8,198.9,3.8,198.8,3.9z"
            />
            <path
                fill={color}
                d="M197.4,3.6c0.2-0.2,0.4-0.3,0.6-0.5C197.2,3.2,197.2,3.2,197.4,3.6z"
            />
            <path
                fill={color}
                d="M193.8,3.8c0.1,0,0.2,0,0.2,0c0-0.1,0-0.2,0-0.4c-0.1,0-0.2,0-0.3,0C193.8,3.6,193.8,3.7,193.8,3.8z"
            />
            <path
                fill={color}
                d="M211.6,2.9c0.1,0.1,0.2,0.2,0.4,0.2c0.1,0,0.2-0.1,0.3-0.1c-0.1-0.1-0.2-0.2-0.3-0.2
        		C211.8,2.8,211.7,2.8,211.6,2.9z"
            />
            <path
                fill={color}
                d="M217.5,3.9c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.1-0.1,0.3-0.2c-0.1-0.1-0.2-0.1-0.3-0.2
        		C217.6,3.8,217.5,3.8,217.5,3.9z"
            />
            <path
                fill={color}
                d="M224.1,5.1c0,0.1,0.2,0.1,0.3,0.1c0.1,0,0.3-0.1,0.3-0.1c0-0.1-0.1-0.2-0.3-0.4C224.1,5,224,5.1,224.1,5.1z"
            />
            <path
                fill={color}
                d="M209.9,4.1c0,0.1,0.1,0.1,0.1,0.2c0.1,0,0.2-0.1,0.3-0.1c0-0.1-0.1-0.2-0.1-0.3C210,4,209.9,4.1,209.9,4.1z"
            />
            <path
                fill={color}
                d="M208.4,3.7c-0.1,0.1-0.2,0.1-0.2,0.2c0,0.1,0.1,0.1,0.2,0.3c0.1-0.1,0.2-0.2,0.2-0.3
        		C208.6,3.8,208.5,3.8,208.4,3.7z"
            />
            <path
                fill={color}
                d="M211.3,5.2c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2-0.1,0.3-0.2c-0.1,0-0.2-0.1-0.3-0.2
        		C211.4,5.1,211.4,5.1,211.3,5.2z"
            />
            <path
                fill={color}
                d="M466.8,98.6c0.1-0.2,0.2-0.3,0.4-0.6C466.8,97.8,466.7,98,466.8,98.6z"
            />
            <path
                fill={color}
                d="M467.4,127.1c0.1-0.7-0.1-1-0.3-1.2C466.9,126.7,467.2,126.8,467.4,127.1z"
            />
            <path
                fill={color}
                d="M466.9,23.8c-0.1-0.2-0.2-0.3-0.2-0.4c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.3,0.1,0.3
        		C466.6,23.9,466.7,23.8,466.9,23.8z"
            />
            <path
                fill={color}
                d="M467.3,22.4c0-0.9,0-0.9-0.4-0.6C467,21.9,467.1,22.1,467.3,22.4z"
            />
            <path
                fill={color}
                d="M467,17.9c0-0.1,0-0.3,0-0.4c-0.1,0-0.2,0.1-0.3,0.1c0,0.1,0,0.3,0,0.3C466.8,17.9,466.9,17.9,467,17.9z"
            />
            <path
                fill={color}
                d="M467.6,12.5c-0.1-0.1-0.1-0.2-0.2-0.3c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0.1,0.2,0.1,0.3
        		C467.5,12.8,467.5,12.7,467.6,12.5z"
            />
            <path
                fill={color}
                d="M467.4,38.6c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.4c-0.1-0.2-0.1-0.3-0.2-0.4
        		C467.5,38.3,467.4,38.4,467.4,38.6z"
            />
            <path
                fill={color}
                d="M466.8,45.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.1,0.2-0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3
        		C466.7,45.4,466.8,45.3,466.8,45.2z"
            />
            <path
                fill={color}
                d="M465.4,52.8c0,0.1,0.1,0.3,0.1,0.3c0.1,0,0.1-0.1,0.4-0.3c-0.2-0.2-0.3-0.3-0.4-0.3
        		C465.5,52.5,465.4,52.7,465.4,52.8z"
            />
            <path
                fill={color}
                d="M466.3,36.6c0.1,0,0.1-0.1,0.3-0.2c-0.1-0.1-0.1-0.3-0.2-0.3c-0.1,0-0.1,0.1-0.2,0.2
        		C466.3,36.4,466.3,36.6,466.3,36.6z"
            />
            <path
                fill={color}
                d="M466.6,34.6c0.1,0,0.1-0.2,0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2c-0.1,0-0.1,0.1-0.2,0.2
        		C466.5,34.5,466.6,34.7,466.6,34.6z"
            />
            <path
                fill={color}
                d="M465.7,38c-0.1-0.1-0.1-0.2-0.2-0.3c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0.1,0.2,0.1,0.3
        		C465.6,38.3,465.6,38.2,465.7,38z"
            />
            <path
                fill={color}
                d="M470,317.7c-0.3-0.4-0.5-0.6-0.7-1c0.5-0.8-0.1-2,0.4-2.9c-0.2-0.2-0.4-0.4-0.6-0.6c0.3-0.7,0.5-1.2,0.7-1.8
        		c-0.5-1,0-2.1-0.1-3.2c-0.1,0-0.2,0-0.3,0c-0.1-1,0-1.7,0.5-2.3c-0.1-0.6-0.6-1-0.3-1.7c0.4-1-0.1-1.1-0.4-1.6
        		c0.3-0.5,0.8-0.9,0.2-1.8c0.2-0.3,0.4-0.5,0.5-0.7c-0.1-0.6-0.2-0.9-0.3-1.3c0.1-0.2,0.2-0.3,0.3-0.4c-0.1-0.6-0.3-1.1-0.4-1.6
        		c0.1-0.2,0.2-0.3,0.4-0.6c-0.2-0.3-0.3-0.6-0.6-1c0.2-0.2,0.4-0.3,0.6-0.5c-0.4-1-0.5-1.9-0.3-2.8c0.3-1.3,0.1-2.4,0-3.5
        		c0.1-0.6,0-1.1,0.2-1.5c0.2-0.7-0.4-0.8-0.2-1.4c0.1-0.3,0.3-0.5,0.5-0.8c-0.2-0.5-0.4-0.9-0.5-1.4c0.2-0.6,0.3-1.2,0.5-1.8
        		c-0.2-0.2-0.3-0.4-0.4-0.6c0-0.3,0-0.6,0.1-0.9c0-0.4,0-0.7,0-1.1c0.1-0.7,0.4-1.5-0.2-2c0.3-0.8-0.1-1.9,0.3-2.6
        		c0.2-0.3,0.2-0.7-0.1-0.9c-0.2-0.2-0.2-0.5-0.3-0.8c0-0.2-0.2-0.4-0.2-0.7c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.3,0.2-0.4
        		c-0.1-0.3-0.2-0.5-0.1-0.8c0-0.6,0.2-1.1,0.2-1.6c0.1-0.9-0.1-1.3-0.6-1.7c0,0-0.1-0.2-0.1-0.4c0.3,0,0.5,0,0.8,0.1
        		c-0.1-0.5-0.1-0.8-0.2-1.2c0-0.3-0.1-0.7-0.1-0.8c0.1-0.2,0.3-0.3,0.5-0.5c-0.2-0.5-0.4-0.9-0.6-1.4c0-0.4,0.1-1,0.2-1.5
        		c0.2-1.3,0.2-1.3-0.3-2c0.4-0.4,0.4-1.3,0.3-1.9c-0.1-0.6-0.1-1.1,0-1.6c0-0.7,0.1-1.4-0.1-2.1c-0.1-0.5,0-0.8,0.1-1.2
        		c0.2-0.7,0.1-1-0.3-1.2c-0.2-1.4,0.4-2.5,0.5-3.9c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2-1.1,0.1-1.6,0.5-2c-0.2-0.6-0.3-0.9-0.2-1.8
        		c0-0.1,0-0.3,0-0.4c-0.4-0.6-0.2-1,0-1.6c0.1-0.3,0.1-1,0-1c-0.4-0.2-0.2-0.9-0.2-1c-0.4-0.6,0.2-1,0.1-1.5c-0.1-0.5-0.3-1.1,0-1.7
        		c0.2-0.3,0-1.3,0-1.9c-0.1-0.8,0.1-1.4,0.3-2.1c-0.1-0.2-0.3-0.3-0.4-0.5c0.2-0.5,0.3-0.9,0.5-1.3c-0.6-0.5-0.5-1.4-0.3-2.2
        		c0.1-0.4,0.1-0.8,0.2-1.3c-0.2,0.1-0.3,0.2-0.5,0.4c0.1-0.7,0-1.4,0.2-1.6c0.4-0.7,0.3-1.2,0-2c-0.2-0.7-0.2-1.7-0.2-2.5
        		c0-0.4,0.3-0.8,0.4-1.2c-0.4-0.7-0.5-1.3-0.4-1.9c0.2-0.9,0.2-2.7,0.1-3.5c-0.1-0.7,0-1.1,0.3-1.3c0,0,0.1-0.2,0.1-0.4
        		c-0.2,0-0.3,0-0.4,0c0.1-1.1,0.2-2.2,0.2-2.9c-0.1-0.2-0.2-0.4-0.2-0.6c0,0,0.1-0.1,0.1-0.1c0.4-0.3,0.1-1.1,0.3-1.6
        		c-0.6-0.7,0-1.3,0-2c-0.1-0.4-0.2-0.9-0.2-1.2c0.3-1,0.2-2,0.1-3c0-0.7,0-1,0.4-1.4c-0.3-0.2-0.5-0.3-0.8-0.4
        		c0.7-1.2,0.7-2.5,0.4-3.8c0.1-0.3,0.3-0.5,0.4-0.7c-0.1-0.3-0.2-0.5-0.3-0.7c-0.1-0.2-0.1-0.4-0.2-0.9c0.2-0.1,0.3-0.3,0.3-0.3
        		c-0.1-0.8-0.3-1.6-0.2-2.1c0.2-1.1,0.1-2.1,0-3.1c-0.1-1.1-0.3-2.3,0.2-3c-0.1-0.5-0.2-0.9-0.1-1.3c0-0.4,0.1-0.8,0.2-1.2
        		c-0.3-0.2-0.5-0.7-0.3-1.4c0.1-0.4,0.2-0.9,0.2-1.3c0.1-0.7,0.1-1.3-0.3-1.6c0.2-0.6,0.3-1,0.5-1.5c-0.2-0.3-0.3-0.6-0.5-1
        		c0.2-0.2,0.4-0.3,0.5-0.3c0-0.6,0-1.2-0.4-1.1c0-0.4,0-0.8,0-1.2c0-0.3-0.1-0.6-0.1-0.9c0.1-0.8,0.4-1.5,0-2.2c0,0,0-0.2,0-0.3
        		c0.2-0.5,0.1-1.2,0.1-1.7c0-0.3,0.2-0.5,0.2-0.8c-0.3-0.9-0.3-0.9,0-3c-0.1,0-0.3-0.1-0.4-0.1c0.2-1.5,0.4-2.9,0.1-4.4
        		c0.2-1.1-0.3-2.4,0.3-3.1c-0.1-0.6-0.2-1-0.3-1.4c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.2-0.3-0.4-0.4-0.4c0.1-0.8,0.2-1.5,0.1-2.1
        		c-0.1-0.7-0.1-1.4,0.1-2c0.1-0.2,0.1-0.5,0.2-0.7c-0.2-0.1-0.3-0.1-0.6-0.2c0.1-0.7,0.3-1.4,0.4-2.1c0-0.1,0-0.2-0.1-0.3
        		c-0.1-0.4-0.3-0.7-0.4-1.1c0.1-0.1,0.2-0.3,0.3-0.4c-0.1-0.5-0.2-0.9-0.2-1.3c0-0.3,0.2-0.6,0.3-0.7c-0.1-0.5-0.3-1-0.3-1.4
        		c0.1-1.8,0-3.7,0.2-5.5c0-0.2,0.1-0.6,0-0.7c-0.5-1.2,0.1-2.4-0.1-3.6c0.6-0.9,0.1-1.4-0.2-2c0.4-0.7,0.6-1.4,0.2-2.3
        		c-0.1-0.1-0.1-0.4,0-0.6c0.2-1-0.1-1.6-0.4-2.3c0.2-0.2,0.4-0.4,0.4-0.4c-0.2-1.1,0.1-2.2,0.1-3.2c0-1.4-0.3-2.7-0.1-4.1
        		c-0.3-0.8,0-1.6,0.1-2.3c0-0.3,0.1-0.8,0.1-0.8c-0.6-0.7-0.1-1.3,0-2c-0.3-1.2-0.3-1.4,0.4-1.5c-0.3-0.4-0.5-0.6-0.7-1
        		c0.5-0.8-0.1-2,0.4-2.9c-0.2-0.2-0.4-0.4-0.6-0.6c0.3-0.7,0.5-1.2,0.7-1.8c-0.5-1,0-2.1-0.1-3.2c-0.1,0-0.2,0-0.3,0
        		c-0.1-1,0-1.7,0.5-2.3c-0.1-0.6-0.6-1-0.3-1.7c0.4-1-0.1-1.1-0.4-1.6c0.3-0.5,0.8-0.9,0.2-1.8c0.2-0.3,0.4-0.5,0.5-0.7
        		c-0.1-0.6-0.2-0.9-0.3-1.3c0.1-0.2,0.2-0.3,0.3-0.4c-0.1-0.6-0.3-1.1-0.4-1.6c0.1-0.2,0.2-0.3,0.4-0.6c-0.2-0.3-0.3-0.6-0.6-1
        		c0.2-0.2,0.4-0.3,0.6-0.5c-0.4-1-0.5-1.9-0.3-2.8c0.3-1.3,0.1-2.4,0-3.5c0.1-0.6,0-1.1,0.2-1.5c0.2-0.7-0.4-0.8-0.2-1.4
        		c0.1-0.3,0.3-0.5,0.5-0.8c-0.2-0.5-0.4-0.9-0.5-1.4c0.2-0.6,0.3-1.2,0.5-1.8c-0.2-0.2-0.3-0.4-0.4-0.6c0-0.3,0-0.6,0.1-0.9
        		c0-0.4,0-0.7,0-1.1c0.1-0.7,0.4-1.5-0.2-2c0.3-0.8-0.1-1.9,0.3-2.6c0.2-0.3,0.2-0.7-0.1-0.9c-0.2-0.2-0.2-0.5-0.3-0.8
        		c0-0.2-0.2-0.4-0.2-0.7c0.1-0.2,0.1-0.3,0.2-0.5c0.1-0.2,0.2-0.3,0.2-0.4c-0.1-0.3-0.2-0.5-0.1-0.8c0-0.6,0.2-1.1,0.2-1.6
        		c0.1-0.9-0.1-1.3-0.6-1.7c0,0-0.1-0.2-0.1-0.4c0.3,0,0.5,0,0.8,0.1c-0.1-0.5-0.1-0.8-0.2-1.2c0-0.3-0.1-0.7-0.1-0.8
        		c0.1-0.2,0.3-0.3,0.5-0.5c-0.2-0.5-0.4-0.9-0.6-1.4c0-0.4,0.1-1,0.2-1.5c0.2-1.3,0.2-1.3-0.3-2c0.4-0.4,0.4-1.3,0.3-1.9
        		c-0.1-0.6-0.1-1.1,0-1.6c0-0.7,0.1-1.4-0.1-2.1c-0.1-0.5,0-0.8,0.1-1.2c0.2-0.7,0.1-1-0.3-1.2c-0.2-1.4,0.4-2.5,0.5-3.9
        		c-0.2,0.1-0.3,0.2-0.5,0.3c-0.2-1.1,0.1-1.6,0.5-2c-0.2-0.6-0.3-0.9-0.2-1.8c0-0.1,0-0.3,0-0.4c-0.4-0.6-0.2-1,0-1.6
        		c0.1-0.3,0.1-1,0-1c-0.4-0.2-0.2-0.9-0.2-1c-0.4-0.6,0.2-1,0.1-1.5c-0.1-0.5-0.3-1.1,0-1.7c0.2-0.3,0-1.3,0-1.9
        		c-0.1-0.8,0.1-1.4,0.3-2.1c-0.1-0.2-0.3-0.3-0.4-0.5c0.2-0.5,0.3-0.9,0.5-1.3c-0.6-0.5-0.5-1.4-0.3-2.2c0.1-0.4,0.1-0.8,0.2-1.3
        		c-0.2,0.1-0.3,0.2-0.5,0.4c0.1-0.7,0-1.4,0.2-1.6c0.4-0.7,0.3-1.2,0-2c-0.2-0.7-0.2-1.7-0.2-2.5c0-0.4,0.3-0.8,0.4-1.2
        		c-0.4-0.7-0.5-1.3-0.4-1.9c0.2-0.9,0.2-2.7,0.1-3.5c-0.1-0.7,0-1.1,0.3-1.3c0,0,0.1-0.2,0.1-0.4c-0.2,0-0.3,0-0.4,0
        		c0.1-1.1,0.2-2.2,0.2-2.9c-0.2-0.6-0.4-0.9-0.5-1.3c-0.2-0.4-0.4-0.9-0.6-1l-0.1,0.5c-0.1-0.1-0.3-0.2-0.6-0.3
        		c-0.2-0.1-0.4-0.2-0.6-0.2c-0.1,0-0.3,0.2-0.4,0.2c-0.2-0.1-0.4-0.3-0.5-0.3c-0.4,0.1-0.4,0-0.5-0.2c-0.2-0.5-0.9-0.2-1.4-0.3
        		c-0.6,0.7-1.1,0-1.7,0c-0.4,0.1-0.8,0.3-1.1,0.2c-0.9-0.3-1.8-0.2-2.6-0.1c-0.6,0.1-0.9,0-1.2-0.4c-0.1,0.4-0.2,0.6-0.4,1
        		c-1-0.8-2.2-0.8-3.3-0.4c-0.2-0.2-0.4-0.3-0.6-0.4c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.4,0.1-0.7,0.3c-0.1-0.2-0.2-0.4-0.2-0.4
        		c-0.7,0.1-1.4,0.3-1.8,0.2c-1-0.3-1.8-0.1-2.7,0c-0.9,0.1-2,0.4-2.6-0.2c-0.4,0.1-0.8,0.2-1.1,0.2c-0.4,0-0.7-0.1-1.1-0.2
        		c-0.2,0.4-0.6,0.5-1.2,0.4c-0.4-0.1-0.7-0.2-1.1-0.3c-0.6-0.1-1.2-0.1-1.4,0.4c-0.5-0.2-0.9-0.4-1.3-0.6c-0.3,0.2-0.5,0.4-0.8,0.6
        		c-0.1-0.3-0.2-0.4-0.3-0.6c-0.5,0-1.1-0.1-1,0.4c-0.4,0-0.7,0-1.1,0c-0.3,0-0.6,0.1-0.8,0.1c-0.7-0.2-1.3-0.5-1.9,0
        		c0,0-0.2,0-0.3,0c-0.5-0.3-1-0.1-1.5-0.1c-0.2,0-0.5-0.2-0.7-0.3c-0.8,0.3-0.8,0.3-2.6,0c0,0.2-0.1,0.3-0.1,0.5
        		c-1.3-0.2-2.5-0.5-3.8-0.1c-0.9-0.3-2.1,0.3-2.7-0.3c-0.5,0.1-0.8,0.2-1.2,0.3c-0.2-0.2-0.4-0.3-0.7-0.5c-0.2,0.2-0.3,0.4-0.4,0.4
        		c-0.7-0.1-1.3-0.2-1.8-0.1c-0.6,0.1-1.2,0.1-1.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0.2-0.1,0.4-0.2,0.7c-0.6-0.2-1.2-0.3-1.8-0.4
        		c-0.1,0-0.2,0-0.2,0.1c-0.3,0.2-0.6,0.3-0.9,0.5c-0.1-0.1-0.2-0.3-0.3-0.4c-0.4,0.1-0.8,0.2-1.1,0.2c-0.3,0-0.5-0.3-0.6-0.3
        		c-0.5,0.1-0.9,0.4-1.2,0.3c-1.6-0.1-3.2,0-4.8-0.3c-0.2,0-0.5-0.1-0.6,0c-1,0.6-2.1-0.1-3.1,0.1c-0.8-0.6-1.2-0.1-1.7,0.3
        		c-0.6-0.5-1.2-0.7-2-0.3c-0.1,0.1-0.4,0.1-0.5,0.1c-0.8-0.2-1.4,0.1-2,0.5c-0.2-0.2-0.3-0.5-0.4-0.4c-1,0.2-1.9-0.1-2.8-0.1
        		c-1.2,0-2.3,0.4-3.5,0.1c-0.7,0.3-1.4,0-2-0.1c-0.2-0.1-0.7-0.1-0.7-0.1c-0.6,0.7-1.2,0.1-1.7,0c-1.1,0.4-1.2,0.4-1.3-0.4
        		c-0.3,0.3-0.5,0.5-0.8,0.8c-0.7-0.6-1.8,0.1-2.5-0.5c-0.2,0.2-0.3,0.5-0.5,0.7c-0.6-0.3-1-0.5-1.6-0.8c-0.9,0.6-1.8,0-2.8,0.1
        		c0,0.1,0,0.2,0,0.4c-0.8,0.1-1.5,0-2-0.5c-0.5,0.1-0.8,0.7-1.5,0.4c-0.9-0.4-1,0.2-1.4,0.4c-0.4-0.3-0.8-0.9-1.6-0.2
        		c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5,0.2-0.8,0.3-1.1,0.4c-0.1-0.1-0.3-0.3-0.3-0.3c-0.5,0.2-0.9,0.3-1.4,0.5c-0.2-0.1-0.3-0.3-0.5-0.5
        		c-0.3,0.2-0.5,0.4-0.8,0.6c0,0-0.1,0-0.1,0c-0.2-0.2-0.3-0.4-0.4-0.6c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0-0.7,0.1-1,0
        		c-0.6,0.7-1.1,0-1.7,0c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.7,0-1.1,0c-0.8-0.2-1.5-0.1-2.3-0.1c-0.6,0.1-0.9,0-1.2-0.4
        		c-0.1,0.3-0.2,0.5-0.3,0.7c-0.2-0.2-0.4-0.3-0.7-0.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.6-0.2-1.2-0.2-1.8,0c-0.1,0-0.3-0.1-0.4-0.1
        		c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.1-0.6,0.2c-0.1,0-0.1,0-0.2,0
        		c-0.1-0.2-0.2-0.3-0.2-0.3c-0.3,0-0.5,0.1-0.7,0.1c-0.3,0-0.5,0-0.7,0.1c-0.1,0-0.2,0-0.3,0c-0.8-0.2-1.5-0.1-2.2-0.1c0,0,0,0,0,0
        		c-0.3-0.2-0.6-0.2-0.7,0.1c0,0,0,0,0,0c-0.9,0.1-1.8,0.3-2.3-0.3c-0.4,0.1-0.8,0.2-1.1,0.2c-0.4,0-0.7-0.1-1.1-0.2
        		c-0.2,0.4-0.6,0.5-1.2,0.4c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0c-0.3-0.1-0.5-0.1-0.8-0.2c-0.4-0.1-0.8-0.1-1,0
        		c0-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.2-0.7,0.4c-0.3-0.1-0.6-0.2-0.8-0.4c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0-0.1,0-0.2,0
        		c-0.1-0.2-0.2-0.4-0.2-0.5c-0.5,0-0.9,0-1,0.3c-0.1,0-0.2,0.1-0.3,0.1c-0.3,0-0.5,0-0.8,0c0,0,0,0-0.1,0c-0.3-0.1-0.7-0.1-1.1-0.1
        		c-0.5-0.1-1-0.3-1.5,0.1c-0.2,0-0.3,0-0.5,0c-0.4-0.1-0.9,0-1.3-0.1c-0.2,0-0.5-0.2-0.7-0.3c-0.8,0.3-0.8,0.3-2.6,0
        		c0,0.2-0.1,0.3-0.1,0.5c-0.4-0.1-0.7-0.1-1-0.2c-0.3-0.1-0.7-0.2-1.1-0.2c0,0,0,0.1,0.1,0.1c-0.4,0-0.9,0-1.3,0.1
        		c-0.1-0.1-0.2-0.2-0.2-0.3c-0.6,0.3-0.8,0.3-1.6,0.2c-0.1,0-0.3,0-0.3,0c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0-0.6-0.1-0.9-0.3
        		c-0.2,0.1-0.4,0.1-0.5,0.1c-0.3,0-0.7,0-0.7,0c0,0,0,0.1-0.1,0.1c-0.2-0.1-0.4-0.3-0.6-0.5c-0.2,0.2-0.3,0.4-0.4,0.4
        		c-0.7-0.1-1.3-0.2-1.8-0.1c-0.6,0.1-1.2,0.1-1.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2c-0.1,0.2-0.1,0.4-0.2,0.6c0,0,0,0,0,0
        		c-0.1,0-0.1,0-0.2,0c-0.6-0.1-1.1-0.3-1.6-0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3
        		c-0.3-0.2-0.6-0.3-0.9-0.4c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.4,0.1-0.6,0.1c-0.3,0-0.5-0.3-0.6-0.3c-0.2,0.1-0.4,0.1-0.6,0.2
        		c-0.3-0.1-0.5-0.1-0.9-0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0,0c-0.5,0-1-0.1-1.5-0.1c-0.4-0.2-0.7-0.2-1.1,0c-0.7,0-1.5,0-2.2-0.2
        		c-0.2,0-0.5-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.5,0.2c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.7,0-1.3-0.2-2-0.1
        		c-0.7-0.6-1.1-0.1-1.6,0.2c-0.1,0-0.1,0-0.2,0c-0.5-0.4-1.1-0.6-1.7-0.3c0,0,0,0,0,0c0-0.1-0.2-0.1-0.3-0.2c0,0.1,0,0.2,0,0.3
        		c-0.1,0-0.3,0-0.4,0c-0.4-0.1-0.7-0.1-1,0c-0.4,0-0.8-0.1-1.2-0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3,0c0,0,0,0,0,0
        		c-0.2-0.5-0.9-0.2-1.4-0.3c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0-0.4,0-0.6,0c-0.2-0.1-0.5-0.2-0.7-0.2c-0.4,0.1-0.8,0.3-1.1,0.2
        		c-0.9-0.3-1.8-0.2-2.6-0.1c-0.6,0.1-0.9,0-1.2-0.4c-0.1,0.2-0.1,0.3-0.2,0.5c-0.2,0-0.5-0.1-0.6,0c-0.1,0.1-0.1,0.1-0.2,0.2
        		c-0.8-0.4-1.7-0.4-2.6-0.1c-0.1-0.1-0.1-0.3-0.2-0.6c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1-0.1-0.2-0.1-0.2-0.2c-0.2,0.1-0.4,0.2-0.6,0.3
        		c-0.1,0.1-0.3,0.1-0.5,0.2c-0.1,0-0.2,0-0.4,0c-0.1-0.1-0.2-0.3-0.2-0.3c-0.3,0-0.7,0.1-0.9,0.2c-0.1,0-0.2-0.1-0.3-0.2
        		c0,0.1-0.1,0.1-0.1,0.2c-0.2,0-0.3,0-0.5,0c-0.4-0.1-0.7-0.1-1.1-0.1c-0.1-0.1-0.2-0.1-0.4-0.2c-0.9,0.6-1.8,0-2.8,0.1
        		c0,0.1,0,0.2,0,0.3c-0.4,0-0.8-0.1-1.1-0.4c-0.2,0-0.4,0.1-0.6,0.1c-0.1-0.1-0.2-0.1-0.2-0.2c-0.2,0-0.3,0.1-0.4,0.2
        		c-0.3,0-0.6-0.1-0.8-0.2c-0.1,0.2-0.2,0.3-0.4,0.3c-0.4-0.1-0.6-0.1-0.8,0c0,0,0,0,0,0c-0.4-0.1-0.7-0.2-1.1-0.3
        		c-0.5-0.1-0.9-0.1-1.2,0.1c-0.1-0.1-0.2-0.2-0.3-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0.1-0.1,0.1-0.2,0.2
        		c0,0,0,0,0,0c-0.2,0.1-0.5,0.2-0.7,0.2c-0.1-0.1-0.1-0.2-0.2-0.3c-0.4,0-0.8,0-0.9,0.1c0,0,0,0-0.1-0.1c-0.2,0.1-0.3,0.2-0.5,0.4
        		c-0.2,0-0.4,0-0.6,0c0,0,0,0,0,0c-0.1-0.1-0.2-0.2-0.2-0.4c-0.3,0.2-0.5,0.3-0.8,0.3c-0.5-0.2-1.1-0.3-1.6,0c0,0,0,0,0,0
        		c-0.7-0.2-1.3-0.2-1.9-0.1c-0.2,0-0.4-0.2-0.6-0.2c-0.8,0.3-0.8,0.3-2.6,0c0,0.1-0.1,0.3-0.1,0.4c0,0-0.1,0-0.1,0
        		c-0.2,0-0.4-0.1-0.5-0.1c-0.2-0.1-0.4-0.3-0.5-0.4c-0.2,0.1-0.3,0.2-0.5,0.3c-0.5-0.1-1.1-0.1-1.6,0c-0.2-0.1-0.4-0.1-0.6-0.2
        		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0-1.7,0.3-2.3-0.2c-0.2,0-0.3,0.1-0.5,0.1c-0.3,0-0.5,0-0.8,0.2c-0.2-0.2-0.4-0.3-0.7-0.5
        		c-0.2,0.2-0.3,0.4-0.4,0.4c-0.6,0-1.1-0.1-1.5-0.1c-0.2-0.1-0.4-0.1-0.5,0c-0.5,0-1,0.1-1.5-0.2c-0.2-0.1-0.4-0.1-0.6-0.2
        		c-0.1,0.2-0.1,0.4-0.2,0.6c0,0,0,0,0,0c-0.6-0.2-1.2-0.3-1.8-0.4c-0.1,0-0.2,0-0.2,0.1c-0.1,0.1-0.3,0.1-0.4,0.2
        		c-0.3,0-0.5,0.1-0.6,0.2c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1,0-0.3,0.1-0.4,0.1c0,0,0-0.1,0-0.1c-0.4,0.1-0.6,0.1-0.8,0.2
        		c-0.2-0.1-0.4-0.2-0.5-0.3c-0.2,0.1-0.4,0.1-0.5,0.2c-0.1-0.1-0.1-0.2-0.2-0.4c-0.3,0.2-0.6,0.3-0.9,0.5c-0.6,0-1.2,0-1.8-0.1
        		c-0.6-0.1-0.8-0.2-1.1,0c-0.5,0-0.9-0.1-1.4-0.1c-0.2,0-0.5-0.1-0.6,0c-0.4,0.2-0.7,0.3-1.1,0.2c-0.1,0-0.1,0-0.2,0
        		c-0.6-0.1-1.2-0.2-1.8-0.1c-0.6-0.5-1-0.3-1.4,0c-0.3-0.1-0.5-0.1-0.6,0c-0.5-0.3-1-0.4-1.7,0c-0.1,0.1-0.4,0.1-0.5,0.1
        		c-0.2,0-0.3,0-0.4,0c-0.3-0.1-0.6-0.2-1-0.2c0.1,0.1,0.1,0.2,0.2,0.3c-0.2,0.1-0.3,0.2-0.5,0.3c-0.1,0-0.2,0-0.3-0.1
        		c-0.1-0.1-0.2-0.3-0.2-0.3c-0.1,0-0.2,0-0.2,0c-0.1-0.1-0.2-0.2-0.3-0.4c-0.6,0.3-0.8,0.3-1.6,0.2c-0.1,0-0.3,0-0.3,0c0,0,0,0,0,0
        		c-0.1,0-0.2,0-0.3,0c-0.3,0-0.6,0-0.9,0.1c-0.1,0-0.1,0-0.2-0.1c-0.2-0.1-0.8-0.1-0.9,0c0,0.1-0.1,0.2-0.2,0.2
        		c-0.5,0-0.9,0-1.4-0.1c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.4,0c-0.1,0-0.2,0-0.3,0.1c-0.4,0-0.7-0.2-1.1-0.3
        		c-0.2-0.1-0.7-0.1-0.7-0.1c0,0-0.1,0.1-0.1,0.1c-0.3,0-0.6,0.1-0.9,0.1c0,0,0,0-0.1,0c-0.2-0.1-0.4-0.2-0.6-0.3
        		c-0.2,0.1-0.3,0.1-0.5,0.2c-0.2-0.1-0.4-0.2-0.7-0.3c0,0-0.1,0.1-0.1,0.1c0-0.1-0.1-0.2-0.1-0.4c-0.2,0.2-0.4,0.4-0.6,0.6
        		c-0.3-0.1-0.5-0.2-0.8-0.4c-0.1,0.2-0.3,0.3-0.4,0.4c-0.5,0-1.1,0.1-1.5-0.2c0,0.1-0.1,0.1-0.1,0.2c-0.3-0.1-0.6-0.1-1-0.2
        		c0.1,0.2,0.2,0.4,0.3,0.6c-0.4-0.2-0.8-0.4-1.3-0.7c-0.2,0.1-0.4,0.2-0.6,0.2c-0.2-0.1-0.4,0-0.6,0c-0.5,0-1-0.2-1.5-0.1
        		c0,0.1,0,0.2,0,0.4c-0.8,0.1-1.5,0-2-0.5c-0.5,0.1-0.8,0.7-1.5,0.4c-0.6-0.3-0.9-0.1-1.1,0.2c-0.2,0-0.4,0-0.7-0.1
        		c-0.3-0.2-0.6-0.3-1,0c-0.1,0-0.2,0-0.2,0c-0.2-0.2-0.4-0.4-0.5-0.5c-0.4,0.1-0.7,0.2-1,0.3c0,0-0.1-0.1-0.1-0.1
        		c0-0.1-0.2-0.1-0.3-0.2c0,0,0,0,0,0c0,0,0,0,0,0c-0.4,0.1-0.7,0.2-1.1,0.4c-0.2,0-0.3,0-0.5,0c-0.1-0.1-0.2-0.2-0.3-0.3
        		c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0-0.2,0-0.3,0c-0.2,0.1-0.3,0.2-0.4,0.2c-0.1-0.2-0.2-0.3-0.3-0.5c-0.1,0-0.2,0.1-0.3,0.1
        		c-0.3,0-0.7,0.1-1,0c-0.6,0.7-1.1,0-1.7,0c-0.1,0-0.2,0.1-0.3,0.1c-0.4,0-0.7,0-1.1,0c-0.8-0.2-1.5-0.1-2.3-0.1
        		c-0.6,0.1-0.9,0-1.2-0.4c-0.1,0.3-0.2,0.5-0.3,0.7c-0.2-0.2-0.4-0.3-0.7-0.5c-0.2,0.1-0.3,0.2-0.5,0.3c-0.6-0.2-1.2-0.2-1.8,0
        		c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0.1-0.1,0.1-0.2,0.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2,0.1-0.4,0.2-0.6,0.3c-0.2,0.1-0.3,0.1-0.6,0.2
        		c-0.1,0-0.1,0-0.2,0C167,0.5,167,0.4,167,0.4c-0.3,0-0.5,0.1-0.7,0.1c-0.3,0-0.5,0-0.7,0.1c-0.1,0-0.2,0-0.3,0
        		c-0.8-0.2-1.5-0.1-2.2-0.1c0,0,0,0,0,0c-0.3-0.2-0.6-0.2-0.7,0.1c0,0,0,0,0,0c-0.9,0.1-1.8,0.3-2.3-0.3c-0.4,0.1-0.8,0.2-1.1,0.2
        		c-0.4,0-0.7-0.1-1.1-0.2c-0.2,0.4-0.6,0.5-1.2,0.4c-0.1,0-0.1,0-0.2-0.1c0,0,0,0,0-0.1c-0.1,0-0.1,0-0.2,0
        		c-0.3-0.1-0.5-0.1-0.8-0.2c-0.4-0.1-0.8-0.1-1,0c0-0.1-0.1-0.2-0.2-0.3c-0.2,0.1-0.4,0.2-0.7,0.4c-0.3-0.1-0.6-0.2-0.8-0.4
        		c-0.3,0.2-0.5,0.4-0.7,0.6c-0.1,0-0.1,0-0.2,0c-0.1-0.2-0.2-0.4-0.2-0.5c-0.5,0-0.9,0-1,0.3c-0.1,0-0.2,0.1-0.3,0.1
        		c-0.3,0-0.5,0-0.8,0c0,0,0,0-0.1,0c-0.3-0.1-0.7-0.1-1.1-0.1c-0.5-0.1-1-0.3-1.5,0.1c-0.2,0-0.3,0-0.5,0c-0.4-0.1-0.9,0-1.3-0.1
        		c-0.2,0-0.5-0.2-0.7-0.3c-0.8,0.3-0.8,0.3-2.6,0c0,0.2-0.1,0.3-0.1,0.5c-0.4-0.1-0.7-0.1-1-0.2c-0.3-0.1-0.7-0.2-1.1-0.2
        		c0,0,0,0.1,0.1,0.1c-0.4,0-0.9,0-1.3,0.1c-0.1-0.1-0.2-0.2-0.2-0.3c-0.6,0.3-0.8,0.3-1.6,0.2c-0.1,0-0.3,0-0.3,0
        		c-0.1,0-0.1,0.1-0.2,0.1c-0.3,0-0.6-0.1-0.9-0.3c-0.2,0.1-0.4,0.1-0.5,0.1c-0.3,0-0.7,0-0.7,0c0,0,0,0.1-0.1,0.1
        		c-0.2-0.1-0.4-0.3-0.6-0.5c-0.2,0.2-0.3,0.4-0.4,0.4c-0.7-0.1-1.3-0.2-1.8-0.1c-0.6,0.1-1.2,0.1-1.7-0.2c-0.2-0.1-0.4-0.1-0.6-0.2
        		c-0.1,0.2-0.1,0.4-0.2,0.6c0,0,0,0,0,0c-0.1,0-0.1,0-0.2,0c-0.6-0.1-1.1-0.3-1.6-0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
        		c-0.1,0-0.1,0-0.2,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.3-0.2-0.6-0.3-0.9-0.4c-0.1,0.2-0.2,0.3-0.4,0.4c-0.2,0.1-0.4,0.1-0.6,0.1
        		c-0.3,0-0.5-0.3-0.6-0.3c-0.2,0.1-0.4,0.1-0.6,0.2c-0.3-0.1-0.5-0.1-0.9-0.2c0.1,0.1,0.1,0.2,0.2,0.3c0,0,0,0,0,0
        		c-0.5,0-1-0.1-1.5-0.1c-0.4-0.2-0.7-0.2-1.1,0c-0.7,0-1.5,0-2.2-0.2c-0.2,0-0.5-0.1-0.6,0c-0.2,0.1-0.4,0.2-0.5,0.2
        		c-0.1-0.1-0.2-0.1-0.3-0.2c-0.1,0.1-0.2,0.1-0.3,0.2c-0.7,0-1.3-0.2-2-0.1c-0.7-0.6-1.1-0.1-1.6,0.2c-0.1,0-0.1,0-0.2,0
        		c-0.5-0.4-1.1-0.6-1.7-0.3c0,0,0,0,0,0c0-0.1-0.2-0.1-0.3-0.2c0,0.1,0,0.2,0,0.3c-0.1,0-0.3,0-0.4,0c-0.4-0.1-0.7-0.1-1,0
        		c-0.4,0-0.8-0.1-1.2-0.1c-0.1,0.1-0.2,0.1-0.3,0.1c-0.9,0.2-1.8-0.1-2.7-0.1c-1.2,0-2.3,0.4-3.5,0.1c-0.7,0.3-1.4,0-2-0.1
        		c-0.2-0.1-0.7-0.1-0.7-0.1c-0.6,0.7-1.2,0.1-1.7,0c-1.1,0.4-1.2,0.4-1.3-0.4c-0.3,0.3-0.5,0.5-0.8,0.8c-0.7-0.6-1.8,0.1-2.5-0.5
        		c-0.2,0.2-0.3,0.5-0.5,0.7c-0.6-0.3-1-0.5-1.6-0.8c-0.9,0.6-1.8,0-2.8,0.1c0,0.1,0,0.2,0,0.4c-0.8,0.1-1.5,0-2-0.5
        		c-0.5,0.1-0.8,0.7-1.5,0.4c-0.9-0.4-1,0.2-1.4,0.4c-0.4-0.3-0.8-0.9-1.6-0.2c-0.2-0.2-0.4-0.4-0.6-0.6c-0.5,0.2-0.8,0.3-1.1,0.4
        		c-0.1-0.1-0.3-0.3-0.3-0.3c-0.5,0.2-0.9,0.3-1.4,0.5c-0.1-0.1-0.3-0.3-0.5-0.5c-0.3,0.2-0.5,0.4-0.9,0.7c-0.2-0.2-0.3-0.4-0.4-0.7
        		c-0.8,0.5-1.7,0.6-2.4,0.4c-1.1-0.3-2.1-0.2-3,0.1c-0.5-0.1-1-0.1-1.3-0.2c-0.6-0.2-0.7,0.4-1.2,0.2c-0.2-0.2-0.4-0.3-0.7-0.5
        		c-0.4,0.2-0.8,0.4-1.2,0.6c-0.5-0.2-1.1-0.3-1.6-0.5c-0.2,0.2-0.4,0.3-0.5,0.4c-0.3,0-0.5-0.1-0.8-0.1c-0.3,0-0.6,0-0.9-0.1
        		c-0.6-0.1-1.3-0.4-1.7,0.2c-0.7-0.3-1.6,0.1-2.3-0.3c-0.3-0.2-0.6-0.2-0.7,0.1c-0.1,0.3-0.4,0.3-0.7,0.3c-0.2,0-0.4,0.2-0.6,0.3
        		C55.4,1,55.2,1,55.1,0.9c-0.1-0.1-0.3-0.2-0.3-0.2c-0.2,0.1-0.5,0.2-0.7,0.2c-0.5,0-0.9-0.2-1.4-0.2c-0.8-0.1-1.2,0.1-1.5,0.7
        		c0,0-0.2,0.1-0.4,0.1c0-0.3,0-0.6,0.1-0.9c-0.4,0.1-0.7,0.1-1,0.2c-0.2,0-0.6,0.1-0.7,0.1C49,0.6,49,0.4,48.8,0.1
        		c-0.4,0.2-0.8,0.4-1.2,0.7c-0.4-0.1-0.9-0.1-1.3-0.2c-1.1-0.3-1.1-0.3-1.7,0.3c-0.4-0.5-1.1-0.5-1.6-0.4c-0.5,0.1-0.9,0.1-1.4,0.1
        		c-0.6,0-1.2-0.1-1.8,0.1c-0.4,0.1-0.7,0-1.1-0.1c-0.6-0.2-0.9-0.1-1,0.3c-1.2,0.3-2.2-0.5-3.4-0.5c0.1,0.2,0.2,0.4,0.3,0.5
        		c-0.9,0.2-1.4-0.1-1.7-0.6c-0.6,0.3-0.8,0.3-1.6,0.2c-0.1,0-0.3,0-0.3,0c-0.5,0.4-0.9,0.2-1.4,0c-0.2-0.1-0.8-0.1-0.9,0
        		c-0.2,0.4-0.8,0.2-0.9,0.3c-0.6,0.4-0.8-0.2-1.3-0.1c-0.5,0.1-0.9,0.3-1.5-0.1c-0.3-0.2-1.1,0-1.6,0c-0.7,0.1-1.2-0.1-1.8-0.4
        		c-0.1,0.2-0.3,0.3-0.4,0.5c-0.4-0.2-0.8-0.4-1.2-0.6c-0.4,0.7-1.2,0.6-1.9,0.4c-0.3-0.1-0.7-0.1-1.1-0.2C16.8,0.6,16.9,0.7,17,1
        		c-0.6-0.1-1.2,0-1.4-0.2c-0.6-0.5-1-0.3-1.7,0c-0.6,0.2-1.5,0.3-2.2,0.2c-0.4,0-0.7-0.3-1.1-0.5C10,0.9,9.5,1,9,0.9
        		C8.2,0.7,6.7,0.7,6,0.8c-0.6,0.1-1,0-1.1-0.4c0-0.1-0.2-0.1-0.3-0.2c0,0.2,0,0.3,0,0.5C3.5,0.6,2.6,0.5,2,0.5c0,0-0.1,0-0.1,0.1
        		C1.9,0.3,1.9,0.2,2,0C1.9,0,1.8,0,1.8,0C1.4,0.1,1.1,0.3,1,1c0,0-0.1,0-0.1,0.1C0.6,1.3,0.1,1.6,0,1.8l0.9,0.4c0,0,0,0.1,0,0.1
        		C0.9,2.5,0.7,2.8,0.7,2.9c0.1,0.4,0,0.5-0.2,0.6C0.1,3.8,0.4,4.6,0.3,5.1c0.6,0.7,0,1.3,0,2C0.4,7.4,0.6,8,0.5,8.3
        		c-0.3,1-0.2,2-0.1,3c0,0.7,0,1-0.4,1.4c0.3,0.2,0.5,0.3,0.8,0.4c-0.7,1.2-0.7,2.5-0.4,3.8c-0.1,0.3-0.3,0.5-0.4,0.7
        		c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.2,0.1,0.4,0.2,0.9c-0.2,0.1-0.3,0.3-0.3,0.3c0.1,0.8,0.3,1.6,0.2,2.1c-0.2,1.1-0.1,2.1,0,3.1
        		c0.1,1.1,0.3,2.3-0.2,3c0.1,0.5,0.2,0.9,0.1,1.3c0,0.4-0.1,0.8-0.2,1.2c0.3,0.2,0.5,0.7,0.3,1.4c-0.1,0.4-0.2,0.9-0.2,1.3
        		c-0.1,0.7-0.1,1.3,0.3,1.6c-0.2,0.6-0.3,1-0.5,1.5c0.2,0.3,0.3,0.6,0.5,1c-0.2,0.2-0.4,0.3-0.5,0.3c0,0.6,0,1.2,0.4,1.1
        		c0,0.4,0,0.8,0,1.2c0,0.3,0.1,0.6,0.1,0.9c-0.1,0.8-0.4,1.5,0,2.2c0,0,0,0.2,0,0.3c-0.2,0.5-0.1,1.2-0.1,1.7c0,0.3-0.2,0.5-0.2,0.8
        		c0.3,0.9,0.3,0.9,0,3c0.1,0,0.3,0.1,0.4,0.1c-0.2,1.5-0.4,2.9-0.1,4.4c-0.2,1.1,0.3,2.4-0.3,3.1c0.1,0.6,0.2,1,0.3,1.4
        		c-0.2,0.3-0.3,0.5-0.4,0.8c0.2,0.2,0.3,0.4,0.4,0.4c-0.1,0.8-0.2,1.5-0.1,2.1c0.1,0.7,0.1,1.4-0.1,2c-0.1,0.2-0.1,0.5-0.2,0.7
        		c0.2,0.1,0.3,0.1,0.6,0.2c-0.1,0.7-0.3,1.4-0.4,2.1c0,0.1,0,0.2,0.1,0.3c0.1,0.4,0.3,0.7,0.4,1.1c-0.1,0.1-0.2,0.3-0.3,0.4
        		c0.1,0.5,0.2,0.9,0.2,1.3c0,0.3-0.2,0.6-0.3,0.7c0.1,0.5,0.3,1,0.3,1.4c-0.1,1.8,0,3.7-0.2,5.5c0,0.2-0.1,0.6,0,0.7
        		c0.5,1.2-0.1,2.4,0.1,3.6c-0.6,0.9-0.1,1.4,0.2,2c-0.4,0.7-0.6,1.4-0.2,2.3c0.1,0.1,0.1,0.4,0,0.6c-0.2,1,0.1,1.6,0.4,2.3
        		c-0.2,0.2-0.4,0.4-0.4,0.4c0.2,1.1-0.1,2.2-0.1,3.2c0,1.4,0.3,2.7,0.1,4.1c0.3,0.8,0,1.6-0.1,2.3c0,0.3-0.1,0.8-0.1,0.8
        		c0.6,0.7,0.1,1.3,0,2c0.3,1.2,0.3,1.4-0.4,1.5c0.3,0.4,0.5,0.6,0.7,1c-0.5,0.8,0.1,2-0.4,2.9c0.2,0.2,0.4,0.4,0.6,0.6
        		c-0.3,0.7-0.5,1.2-0.7,1.8c0.5,1,0,2.1,0.1,3.2c0.1,0,0.2,0,0.3,0c0.1,1,0,1.7-0.5,2.3c0.1,0.6,0.6,1,0.3,1.7
        		c-0.4,1,0.1,1.1,0.4,1.6c-0.3,0.5-0.8,0.9-0.2,1.8c-0.2,0.3-0.4,0.5-0.5,0.7c0.1,0.6,0.2,0.9,0.3,1.3c-0.1,0.2-0.2,0.3-0.3,0.4
        		c0.1,0.6,0.3,1.1,0.4,1.6c-0.1,0.2-0.2,0.3-0.4,0.6c0.2,0.3,0.3,0.6,0.6,1c-0.2,0.2-0.4,0.3-0.6,0.5c0.4,1,0.5,1.9,0.3,2.8
        		c-0.3,1.3-0.1,2.4,0,3.5c-0.1,0.6,0,1.1-0.2,1.5c-0.2,0.7,0.4,0.8,0.2,1.4c-0.1,0.3-0.3,0.5-0.5,0.8c0.2,0.5,0.4,0.9,0.5,1.4
        		c-0.2,0.6-0.3,1.2-0.5,1.8c0.2,0.2,0.3,0.4,0.4,0.6c0,0.3,0,0.6-0.1,0.9c0,0.4,0,0.7,0,1.1c-0.1,0.7-0.4,1.5,0.2,2
        		c-0.3,0.8,0.1,1.9-0.3,2.6c-0.2,0.3-0.2,0.7,0.1,0.9c0.2,0.2,0.2,0.5,0.3,0.8c0,0.2,0.2,0.4,0.2,0.7c-0.1,0.2-0.1,0.3-0.2,0.5
        		c-0.1,0.2-0.2,0.3-0.2,0.4c0.1,0.3,0.2,0.5,0.1,0.8c0,0.6-0.2,1.1-0.2,1.6c-0.1,0.9,0.1,1.3,0.6,1.7c0,0,0.1,0.2,0.1,0.4
        		c-0.3,0-0.5,0-0.8-0.1c0.1,0.5,0.1,0.8,0.2,1.2c0,0.3,0.1,0.7,0.1,0.8c-0.1,0.2-0.3,0.3-0.5,0.5c0.2,0.5,0.4,0.9,0.6,1.4
        		c0,0.4-0.1,1-0.2,1.5c-0.2,1.3-0.2,1.3,0.3,2c-0.4,0.4-0.4,1.3-0.3,1.9c0.1,0.6,0.1,1.1,0,1.6c0,0.7-0.1,1.4,0.1,2.1
        		c0.1,0.5,0,0.8-0.1,1.2c-0.2,0.7-0.1,1,0.3,1.2c0.2,1.4-0.4,2.5-0.5,3.9c0.2-0.1,0.3-0.2,0.5-0.3c0.2,1.1-0.1,1.6-0.5,2
        		c0.2,0.6,0.3,0.9,0.2,1.8c0,0.1,0,0.3,0,0.4c0.4,0.6,0.2,1,0,1.6c-0.1,0.3-0.1,1,0,1c0.4,0.2,0.2,0.9,0.2,1c0.4,0.6-0.2,1-0.1,1.5
        		c0.1,0.5,0.3,1.1,0,1.7c-0.2,0.3,0,1.3,0,1.9c0.1,0.8-0.1,1.4-0.3,2.1c0.1,0.2,0.3,0.3,0.4,0.5c-0.2,0.5-0.3,0.9-0.5,1.3
        		c0.6,0.5,0.5,1.4,0.3,2.2c-0.1,0.4-0.1,0.8-0.2,1.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.1,0.7,0,1.4-0.2,1.6c-0.4,0.7-0.3,1.2,0,2
        		c0.2,0.7,0.2,1.7,0.2,2.5c0,0.4-0.3,0.8-0.4,1.2c0.4,0.7,0.5,1.3,0.4,1.9c-0.2,0.9-0.2,2.7-0.1,3.5c0.1,0.7,0,1.1-0.3,1.3
        		c0,0-0.1,0.2-0.1,0.4c0.2,0,0.3,0,0.4,0c-0.1,1.1-0.2,2.2-0.2,2.9c0.1,0.2,0.2,0.4,0.2,0.6c0,0-0.1,0.1-0.1,0.1
        		c-0.4,0.3-0.1,1.1-0.3,1.6c0.6,0.7,0,1.3,0,2c0.1,0.4,0.2,0.9,0.2,1.2c-0.3,1-0.2,2-0.1,3c0,0.7,0,1-0.4,1.4
        		c0.3,0.2,0.5,0.3,0.8,0.4c-0.7,1.2-0.7,2.5-0.4,3.8c-0.1,0.3-0.3,0.5-0.4,0.7c0.1,0.3,0.2,0.5,0.3,0.7c0.1,0.2,0.1,0.4,0.2,0.9
        		c-0.2,0.1-0.3,0.3-0.3,0.3c0.1,0.8,0.3,1.6,0.2,2.1c-0.2,1.1-0.1,2.1,0,3.1c0.1,1.1,0.3,2.3-0.2,3c0.1,0.5,0.2,0.9,0.1,1.3
        		c0,0.4-0.1,0.8-0.2,1.2c0.3,0.2,0.5,0.7,0.3,1.4c-0.1,0.4-0.2,0.9-0.2,1.3c-0.1,0.7-0.1,1.3,0.3,1.6c-0.2,0.6-0.3,1-0.5,1.5
        		c0.2,0.3,0.3,0.6,0.5,1c-0.2,0.2-0.4,0.3-0.5,0.3c0,0.6,0,1.2,0.4,1.1c0,0.4,0,0.8,0,1.2c0,0.3,0.1,0.6,0.1,0.9
        		c-0.1,0.8-0.4,1.5,0,2.2c0,0,0,0.2,0,0.3c-0.2,0.5-0.1,1.2-0.1,1.7c0,0.3-0.2,0.5-0.2,0.8c0.3,0.9,0.3,0.9,0,3
        		c0.1,0,0.3,0.1,0.4,0.1c-0.2,1.5-0.4,2.9-0.1,4.4c-0.2,1.1,0.3,2.4-0.3,3.1c0.1,0.6,0.2,1,0.3,1.4c-0.2,0.3-0.3,0.5-0.4,0.8
        		c0.2,0.2,0.3,0.4,0.4,0.4c-0.1,0.8-0.2,1.5-0.1,2.1c0.1,0.7,0.1,1.4-0.1,2c-0.1,0.2-0.1,0.5-0.2,0.7c0.2,0.1,0.3,0.1,0.6,0.2
        		c-0.1,0.7-0.3,1.4-0.4,2.1c0,0.1,0,0.2,0.1,0.3c0.1,0.4,0.3,0.7,0.4,1.1c-0.1,0.1-0.2,0.3-0.3,0.4c0.1,0.5,0.2,0.9,0.2,1.3
        		c0,0.3-0.2,0.6-0.3,0.7c0.1,0.5,0.3,1,0.3,1.4c-0.1,1.8,0,3.7-0.2,5.5c0,0.2-0.1,0.6,0,0.7c0.5,1.2-0.1,2.4,0.1,3.6
        		c-0.6,0.9-0.1,1.4,0.2,2c-0.4,0.7-0.6,1.4-0.2,2.3c0.1,0.1,0.1,0.4,0,0.6c-0.2,1,0.1,1.6,0.4,2.3c-0.2,0.2-0.4,0.4-0.4,0.4
        		c0.2,1.1-0.1,2.2-0.1,3.2c0,1.4,0.3,2.7,0.1,4.1c0.3,0.8,0,1.6-0.1,2.3c0,0.3-0.1,0.8-0.1,0.8c0.6,0.7,0.1,1.3,0,2
        		c0.3,1.2,0.3,1.4-0.4,1.5c0.3,0.4,0.5,0.6,0.7,1c-0.5,0.8,0.1,2-0.4,2.9c0.2,0.2,0.4,0.4,0.6,0.6c-0.3,0.7-0.5,1.2-0.7,1.8
        		c0.5,1,0,2.1,0.1,3.2c0.1,0,0.2,0,0.3,0c0.1,1,0,1.7-0.5,2.3c0.1,0.6,0.6,1,0.3,1.7c-0.4,1,0.1,1.1,0.4,1.6
        		c-0.3,0.5-0.8,0.9-0.2,1.8c-0.2,0.3-0.4,0.5-0.5,0.7c0.1,0.6,0.2,0.9,0.3,1.3c-0.1,0.2-0.2,0.3-0.3,0.4c0.1,0.6,0.3,1.1,0.4,1.6
        		c-0.1,0.2-0.2,0.3-0.4,0.6c0.2,0.3,0.3,0.6,0.6,1c-0.2,0.2-0.4,0.3-0.6,0.5c0.4,1,0.5,1.9,0.3,2.8c-0.3,1.3-0.1,2.4,0,3.5
        		c-0.1,0.6,0,1.1-0.2,1.5c-0.2,0.7,0.4,0.8,0.2,1.4c-0.1,0.3-0.3,0.5-0.5,0.8c0.2,0.5,0.4,0.9,0.5,1.4c-0.2,0.6-0.3,1.2-0.5,1.8
        		c0.2,0.2,0.3,0.4,0.4,0.6c0,0.3,0,0.6-0.1,0.9c0,0.4,0,0.7,0,1.1c-0.1,0.7-0.4,1.5,0.2,2c-0.3,0.8,0.1,1.9-0.3,2.6
        		c-0.2,0.3-0.2,0.7,0.1,0.9c0.2,0.2,0.2,0.5,0.3,0.8c0,0.2,0.2,0.4,0.2,0.7c-0.1,0.2-0.1,0.3-0.2,0.5c-0.1,0.2-0.2,0.3-0.2,0.4
        		c0.1,0.3,0.2,0.5,0.1,0.8c0,0.6-0.2,1.1-0.2,1.6c-0.1,0.9,0.1,1.3,0.6,1.7c0,0,0.1,0.2,0.1,0.4c-0.3,0-0.5,0-0.8-0.1
        		c0.1,0.5,0.1,0.8,0.2,1.2c0,0.3,0.1,0.7,0.1,0.8c-0.1,0.2-0.3,0.3-0.5,0.5c0.2,0.5,0.4,0.9,0.6,1.4c0,0.4-0.1,1-0.2,1.5
        		c-0.2,1.3-0.2,1.3,0.3,2c-0.4,0.4-0.4,1.3-0.3,1.9c0.1,0.6,0.1,1.1,0,1.6c0,0.7-0.1,1.4,0.1,2.1c0.1,0.5,0,0.8-0.1,1.2
        		c-0.2,0.7-0.1,1,0.3,1.2c0.2,1.4-0.4,2.5-0.5,3.9c0.2-0.1,0.3-0.2,0.5-0.3c0.2,1.1-0.1,1.6-0.5,2c0.2,0.6,0.3,0.9,0.2,1.8
        		c0,0.1,0,0.3,0,0.4c0.4,0.6,0.2,1,0,1.6c-0.1,0.3-0.1,1,0,1c0.4,0.2,0.2,0.9,0.2,1c0.4,0.6-0.2,1-0.1,1.5c0.1,0.5,0.3,1.1,0,1.7
        		c-0.2,0.3,0,1.3,0,1.9c0.1,0.8-0.1,1.4-0.3,2.1c0.1,0.2,0.3,0.3,0.4,0.5c-0.2,0.5-0.3,0.9-0.5,1.3c0.6,0.5,0.5,1.4,0.3,2.2
        		c-0.1,0.4-0.1,0.8-0.2,1.3c0.2-0.1,0.3-0.2,0.5-0.4c-0.1,0.7,0,1.4-0.2,1.6c-0.4,0.7-0.3,1.2,0,2c0.2,0.7,0.2,1.7,0.2,2.5
        		c0,0.4-0.3,0.8-0.4,1.2c0.4,0.7,0.5,1.3,0.4,1.9c-0.2,0.9-0.2,2.7-0.1,3.5c0.1,0.7,0,1.1-0.3,1.3c0,0-0.1,0.2-0.1,0.4
        		c0.2,0,0.3,0,0.4,0c-0.1,1.1-0.2,2.2-0.2,2.9c0.2,0.6,0.4,0.9,0.5,1.3c0.2,0.4,0.4,0.9,0.6,1l0.1-0.5c0.1,0.1,0.3,0.2,0.6,0.3
        		c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.3-0.2,0.4-0.2c0.2,0.1,0.4,0.3,0.5,0.3c0.4-0.1,0.4,0,0.5,0.2c0.2,0.5,0.9,0.2,1.4,0.3
        		c0.6-0.7,1.1,0,1.7,0c0.4-0.1,0.8-0.3,1.1-0.2c0.9,0.3,1.8,0.2,2.6,0.1c0.6-0.1,0.9,0,1.2,0.4c0.1-0.4,0.2-0.6,0.4-1
        		c1,0.8,2.2,0.8,3.3,0.4c0.2,0.2,0.4,0.3,0.6,0.4c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.4-0.1,0.7-0.3c0.1,0.2,0.2,0.4,0.2,0.4
        		c0.7-0.1,1.4-0.3,1.8-0.2c1,0.3,1.8,0.1,2.7,0c0.9-0.1,2-0.4,2.6,0.2c0.4-0.1,0.8-0.2,1.1-0.2c0.4,0,0.7,0.1,1.1,0.2
        		c0.2-0.4,0.6-0.5,1.2-0.4c0.4,0.1,0.7,0.2,1.1,0.3c0.6,0.1,1.2,0.1,1.4-0.4c0.5,0.2,0.9,0.4,1.3,0.6c0.3-0.2,0.5-0.4,0.8-0.6
        		c0.1,0.3,0.2,0.4,0.3,0.6c0.5,0,1.1,0.1,1-0.4c0.4,0,0.7,0,1.1,0c0.3,0,0.6-0.1,0.8-0.1c0.7,0.2,1.3,0.5,1.9,0c0,0,0.2,0,0.3,0
        		c0.5,0.3,1,0.1,1.5,0.1c0.2,0,0.5,0.2,0.7,0.3c0.8-0.3,0.8-0.3,2.6,0c0-0.2,0.1-0.3,0.1-0.5c1.3,0.2,2.5,0.5,3.8,0.1
        		c0.9,0.3,2.1-0.3,2.7,0.3c0.5-0.1,0.8-0.2,1.2-0.3c0.2,0.2,0.4,0.3,0.7,0.5c0.2-0.2,0.3-0.4,0.4-0.4c0.7,0.1,1.3,0.2,1.8,0.1
        		c0.6-0.1,1.2-0.1,1.7,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.1-0.4,0.2-0.7c0.6,0.2,1.2,0.3,1.8,0.4c0.1,0,0.2,0,0.2-0.1
        		c0.3-0.2,0.6-0.3,0.9-0.5c0.1,0.1,0.2,0.3,0.3,0.4c0.4-0.1,0.8-0.2,1.1-0.2c0.3,0,0.5,0.3,0.6,0.3c0.5-0.1,0.9-0.4,1.2-0.3
        		c1.6,0.1,3.2,0,4.8,0.3c0.2,0,0.5,0.1,0.6,0c1-0.6,2.1,0.1,3.1-0.1c0.8,0.6,1.2,0.1,1.7-0.3c0.6,0.5,1.2,0.7,2,0.3
        		c0.1-0.1,0.4-0.1,0.5-0.1c0.8,0.2,1.4-0.1,2-0.5c0.2,0.2,0.3,0.5,0.4,0.4c1-0.2,1.9,0.1,2.8,0.1c1.2,0,2.3-0.4,3.5-0.1
        		c0.7-0.3,1.4,0,2,0.1c0.2,0.1,0.7,0.1,0.7,0.1c0.6-0.7,1.2-0.1,1.7,0c1.1-0.4,1.2-0.4,1.3,0.4c0.3-0.3,0.5-0.5,0.8-0.8
        		c0.7,0.6,1.8-0.1,2.5,0.5c0.2-0.2,0.3-0.5,0.5-0.7c0.6,0.3,1,0.5,1.6,0.8c0.9-0.6,1.8,0,2.8-0.1c0-0.1,0-0.2,0-0.4
        		c0.8-0.1,1.5,0,2,0.5c0.5-0.1,0.8-0.7,1.5-0.4c0.9,0.4,1-0.2,1.4-0.4c0.4,0.3,0.8,0.9,1.6,0.2c0.2,0.2,0.4,0.4,0.6,0.6
        		c0.5-0.2,0.8-0.3,1.1-0.4c0.1,0.1,0.3,0.3,0.3,0.3c0.5-0.2,0.9-0.3,1.4-0.5c0.2,0.1,0.3,0.3,0.5,0.5c0.3-0.2,0.5-0.4,0.8-0.6
        		c0,0,0.1,0,0.1,0c0.2,0.2,0.3,0.4,0.4,0.6c0.1,0,0.2-0.1,0.3-0.1c0.3,0,0.7-0.1,1,0c0.6-0.7,1.1,0,1.7,0c0.1,0,0.2-0.1,0.3-0.1
        		c0.4,0,0.7,0,1.1,0c0.8,0.2,1.5,0.1,2.3,0.1c0.6-0.1,0.9,0,1.2,0.4c0.1-0.3,0.2-0.5,0.3-0.7c0.2,0.2,0.4,0.3,0.7,0.5
        		c0.2-0.1,0.3-0.2,0.5-0.3c0.6,0.2,1.2,0.2,1.8,0c0.1,0,0.3,0.1,0.4,0.1c0.1-0.1,0.1-0.1,0.2-0.1c0.2,0.1,0.3,0.2,0.5,0.3
        		c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.1,0.6-0.2c0.1,0,0.1,0,0.2,0c0.1,0.2,0.2,0.3,0.2,0.3c0.3,0,0.5-0.1,0.7-0.1
        		c0.3,0,0.5,0,0.7-0.1c0.1,0,0.2,0,0.3,0c0.8,0.2,1.5,0.1,2.2,0.1c0,0,0,0,0,0c0.3,0.2,0.6,0.2,0.7-0.1c0,0,0,0,0,0
        		c0.9-0.1,1.8-0.3,2.3,0.3c0.4-0.1,0.8-0.2,1.1-0.2c0.4,0,0.7,0.1,1.1,0.2c0.2-0.4,0.6-0.5,1.2-0.4c0.1,0,0.1,0,0.2,0.1
        		c0,0,0,0,0,0.1c0.1,0,0.1,0,0.2,0c0.3,0.1,0.5,0.1,0.8,0.2c0.4,0.1,0.8,0.1,1,0c0,0.1,0.1,0.2,0.2,0.3c0.2-0.1,0.4-0.2,0.7-0.4
        		c0.3,0.1,0.6,0.2,0.8,0.4c0.3-0.2,0.5-0.4,0.7-0.6c0.1,0,0.1,0,0.2,0c0.1,0.2,0.2,0.4,0.2,0.5c0.5,0,0.9,0,1-0.3
        		c0.1,0,0.2-0.1,0.3-0.1c0.3,0,0.5,0,0.8,0c0,0,0,0,0.1,0c0.3,0.1,0.7,0.1,1.1,0.1c0.5,0.1,1,0.3,1.5-0.1c0.2,0,0.3,0,0.5,0
        		c0.4,0.1,0.9,0,1.3,0.1c0.2,0,0.5,0.2,0.7,0.3c0.8-0.3,0.8-0.3,2.6,0c0-0.2,0.1-0.3,0.1-0.5c0.4,0.1,0.7,0.1,1,0.2
        		c0.3,0.1,0.7,0.2,1.1,0.2c0,0,0-0.1-0.1-0.1c0.4,0,0.9,0,1.3-0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.6-0.3,0.8-0.3,1.6-0.2
        		c0.1,0,0.3,0,0.3,0c0.1,0,0.1-0.1,0.2-0.1c0.3,0,0.6,0.1,0.9,0.3c0.2-0.1,0.4-0.1,0.5-0.1c0.3,0,0.7,0,0.7,0c0,0,0-0.1,0.1-0.1
        		c0.2,0.1,0.4,0.3,0.6,0.5c0.2-0.2,0.3-0.4,0.4-0.4c0.7,0.1,1.3,0.2,1.8,0.1c0.6-0.1,1.2-0.1,1.7,0.2c0.2,0.1,0.4,0.1,0.6,0.2
        		c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.6,0.1,1.1,0.3,1.6,0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
        		c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.3,0.2,0.6,0.3,0.9,0.4c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.4-0.1,0.6-0.1
        		c0.3,0,0.5,0.3,0.6,0.3c0.2-0.1,0.4-0.1,0.6-0.2c0.3,0.1,0.5,0.1,0.9,0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0,0
        		c0.5,0,1,0.1,1.5,0.1c0.4,0.2,0.7,0.2,1.1,0c0.7,0,1.5,0,2.2,0.2c0.2,0,0.5,0.1,0.6,0c0.2-0.1,0.4-0.2,0.5-0.2
        		c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.7,0,1.3,0.2,2,0.1c0.7,0.6,1.1,0.1,1.6-0.2c0.1,0,0.1,0,0.2,0
        		c0.5,0.4,1.1,0.6,1.7,0.3c0,0,0,0,0,0c0,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.2,0-0.3c0.1,0,0.3,0,0.4,0c0.4,0.1,0.7,0.1,1,0
        		c0.4,0,0.8,0.1,1.2,0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0c0.2,0.5,0.9,0.2,1.4,0.3c0.1-0.1,0.2-0.2,0.4-0.3
        		c0.2,0,0.4,0,0.6,0c0.2,0.1,0.5,0.2,0.7,0.2c0.4-0.1,0.8-0.3,1.1-0.2c0.9,0.3,1.8,0.2,2.6,0.1c0.6-0.1,0.9,0,1.2,0.4
        		c0.1-0.2,0.1-0.3,0.2-0.5c0.2,0,0.5,0.1,0.6,0c0.1-0.1,0.1-0.1,0.2-0.2c0.8,0.4,1.7,0.4,2.6,0.1c0.1,0.1,0.1,0.3,0.2,0.6
        		c0.1-0.1,0.2-0.2,0.3-0.3c0.1,0.1,0.2,0.1,0.2,0.2c0.2-0.1,0.4-0.2,0.6-0.3c0.1-0.1,0.3-0.1,0.5-0.2c0.1,0,0.2,0,0.4,0
        		c0.1,0.1,0.2,0.3,0.2,0.3c0.3,0,0.7-0.1,0.9-0.2c0.1,0,0.2,0.1,0.3,0.2c0-0.1,0.1-0.1,0.1-0.2c0.2,0,0.3,0,0.5,0
        		c0.4,0.1,0.7,0.1,1.1,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0.9-0.6,1.8,0,2.8-0.1c0-0.1,0-0.2,0-0.3c0.4,0,0.8,0.1,1.1,0.4
        		c0.2,0,0.4-0.1,0.6-0.1c0.1,0.1,0.2,0.1,0.2,0.2c0.2,0,0.3-0.1,0.4-0.2c0.3,0,0.6,0.1,0.8,0.2c0.1-0.2,0.2-0.3,0.4-0.3
        		c0.4,0.1,0.6,0.1,0.8,0c0,0,0,0,0,0c0.4,0.1,0.7,0.2,1.1,0.3c0.5,0.1,0.9,0.1,1.2-0.1c0.1,0.1,0.2,0.2,0.3,0.3
        		c0.2-0.1,0.4-0.1,0.6-0.2c0.2,0.1,0.4,0.2,0.6,0.3c0.1-0.1,0.1-0.1,0.2-0.2c0,0,0,0,0,0c0.2-0.1,0.5-0.2,0.7-0.2
        		c0.1,0.1,0.1,0.2,0.2,0.3c0.4,0,0.8,0,0.9-0.1c0,0,0,0,0.1,0.1c0.2-0.1,0.3-0.2,0.5-0.4c0.2,0,0.4,0,0.6,0c0,0,0,0,0,0
        		c0.1,0.1,0.2,0.2,0.2,0.4c0.3-0.2,0.5-0.3,0.8-0.3c0.5,0.2,1.1,0.3,1.6,0c0,0,0,0,0,0c0.7,0.2,1.3,0.2,1.9,0.1
        		c0.2,0,0.4,0.2,0.6,0.2c0.8-0.3,0.8-0.3,2.6,0c0-0.1,0.1-0.3,0.1-0.4c0,0,0.1,0,0.1,0c0.2,0,0.4,0.1,0.5,0.1
        		c0.2,0.1,0.4,0.3,0.5,0.4c0.2-0.1,0.3-0.2,0.5-0.3c0.5,0.1,1.1,0.1,1.6,0c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.1,0.2-0.2,0.3-0.3
        		c0.8,0,1.7-0.3,2.3,0.2c0.2,0,0.3-0.1,0.5-0.1c0.3,0,0.5,0,0.8-0.2c0.2,0.2,0.4,0.3,0.7,0.5c0.2-0.2,0.3-0.4,0.4-0.4
        		c0.6,0,1.1,0.1,1.5,0.1c0.2,0.1,0.4,0.1,0.5,0c0.5,0,1-0.1,1.5,0.2c0.2,0.1,0.4,0.1,0.6,0.2c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0,0,0,0
        		c0.6,0.2,1.2,0.3,1.8,0.4c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.3-0.1,0.4-0.2c0.3,0,0.5-0.1,0.6-0.2c0.1,0.1,0.2,0.2,0.3,0.3
        		c0.1,0,0.3-0.1,0.4-0.1c0,0,0,0.1,0,0.1c0.4-0.1,0.6-0.1,0.8-0.2c0.2,0.1,0.4,0.2,0.5,0.3c0.2-0.1,0.4-0.1,0.5-0.2
        		c0.1,0.1,0.1,0.2,0.2,0.4c0.3-0.2,0.6-0.3,0.9-0.5c0.6,0,1.2,0,1.8,0.1c0.6,0.1,0.8,0.2,1.1,0c0.5,0,0.9,0.1,1.4,0.1
        		c0.2,0,0.5,0.1,0.6,0c0.4-0.2,0.7-0.3,1.1-0.2c0.1,0,0.1,0,0.2,0c0.6,0.1,1.2,0.2,1.8,0.1c0.6,0.5,1,0.3,1.4,0
        		c0.3,0.1,0.5,0.1,0.6,0c0.5,0.3,1,0.4,1.7,0c0.1-0.1,0.4-0.1,0.5-0.1c0.2,0,0.3,0,0.4,0c0.3,0.1,0.6,0.2,1,0.2
        		c-0.1-0.1-0.1-0.2-0.2-0.3c0.2-0.1,0.3-0.2,0.5-0.3c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.2,0.3,0.2,0.3c0.1,0,0.2,0,0.2,0
        		c0.1,0.1,0.2,0.2,0.3,0.4c0.6-0.3,0.8-0.3,1.6-0.2c0.1,0,0.3,0,0.3,0c0,0,0,0,0,0c0.1,0,0.2,0,0.3,0c0.3,0,0.6,0,0.9-0.1
        		c0.1,0,0.1,0,0.2,0.1c0.2,0.1,0.8,0.1,0.9,0c0-0.1,0.1-0.2,0.2-0.2c0.5,0,0.9,0,1.4,0.1c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.4,0
        		c0.1,0,0.2,0,0.3-0.1c0.4,0,0.7,0.2,1.1,0.3c0.2,0.1,0.7,0.1,0.7,0.1c0,0,0.1-0.1,0.1-0.1c0.3,0,0.6-0.1,0.9-0.1c0,0,0,0,0.1,0
        		c0.2,0.1,0.4,0.2,0.6,0.3c0.2-0.1,0.3-0.1,0.5-0.2c0.2,0.1,0.4,0.2,0.7,0.3c0,0,0.1-0.1,0.1-0.1c0,0.1,0.1,0.2,0.1,0.4
        		c0.2-0.2,0.4-0.4,0.6-0.6c0.3,0.1,0.5,0.2,0.8,0.4c0.1-0.2,0.3-0.3,0.4-0.4c0.5,0,1.1-0.1,1.5,0.2c0-0.1,0.1-0.1,0.1-0.2
        		c0.3,0.1,0.6,0.1,1,0.2c-0.1-0.2-0.2-0.4-0.3-0.6c0.4,0.2,0.8,0.4,1.3,0.7c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0.1,0.4,0,0.6,0
        		c0.5,0,1,0.2,1.5,0.1c0-0.1,0-0.2,0-0.4c0.8-0.1,1.5,0,2,0.5c0.5-0.1,0.8-0.7,1.5-0.4c0.6,0.3,0.9,0.1,1.1-0.2c0.2,0,0.4,0,0.7,0.1
        		c0.3,0.2,0.6,0.3,1,0c0.1,0,0.2,0,0.2,0c0.2,0.2,0.4,0.4,0.5,0.5c0.4-0.1,0.7-0.2,1-0.3c0,0,0.1,0.1,0.1,0.1c0,0.1,0.2,0.1,0.3,0.2
        		c0,0,0,0,0,0c0,0,0,0,0,0c0.4-0.1,0.7-0.2,1.1-0.4c0.2,0,0.3,0,0.5,0c0.1,0.1,0.2,0.2,0.3,0.3c0.1-0.1,0.2-0.2,0.3-0.3
        		c0.1,0,0.2,0,0.3,0c0.2-0.1,0.3-0.2,0.4-0.2c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0,0.2-0.1,0.3-0.1c0.3,0,0.7-0.1,1,0c0.6-0.7,1.1,0,1.7,0
        		c0.1,0,0.2-0.1,0.3-0.1c0.4,0,0.7,0,1.1,0c0.8,0.2,1.5,0.1,2.3,0.1c0.6-0.1,0.9,0,1.2,0.4c0.1-0.3,0.2-0.5,0.3-0.7
        		c0.2,0.2,0.4,0.3,0.7,0.5c0.2-0.1,0.3-0.2,0.5-0.3c0.6,0.2,1.2,0.2,1.8,0c0.1,0,0.3,0.1,0.4,0.1c0.1-0.1,0.1-0.1,0.2-0.1
        		c0.2,0.1,0.3,0.2,0.5,0.3c0.2-0.1,0.4-0.2,0.6-0.3c0.2-0.1,0.3-0.1,0.6-0.2c0.1,0,0.1,0,0.2,0c0.1,0.2,0.2,0.3,0.2,0.3
        		c0.3,0,0.5-0.1,0.7-0.1c0.3,0,0.5,0,0.7-0.1c0.1,0,0.2,0,0.3,0c0.8,0.2,1.5,0.1,2.2,0.1c0,0,0,0,0,0c0.3,0.2,0.6,0.2,0.7-0.1
        		c0,0,0,0,0,0c0.9-0.1,1.8-0.3,2.3,0.3c0.4-0.1,0.8-0.2,1.1-0.2c0.4,0,0.7,0.1,1.1,0.2c0.2-0.4,0.6-0.5,1.2-0.4c0.1,0,0.1,0,0.2,0.1
        		c0,0,0,0,0,0.1c0.1,0,0.1,0,0.2,0c0.3,0.1,0.5,0.1,0.8,0.2c0.4,0.1,0.8,0.1,1,0c0,0.1,0.1,0.2,0.2,0.3c0.2-0.1,0.4-0.2,0.7-0.4
        		c0.3,0.1,0.6,0.2,0.8,0.4c0.3-0.2,0.5-0.4,0.7-0.6c0.1,0,0.1,0,0.2,0c0.1,0.2,0.2,0.4,0.2,0.5c0.5,0,0.9,0,1-0.3
        		c0.1,0,0.2-0.1,0.3-0.1c0.3,0,0.5,0,0.8,0c0,0,0,0,0.1,0c0.3,0.1,0.7,0.1,1.1,0.1c0.5,0.1,1,0.3,1.5-0.1c0.2,0,0.3,0,0.5,0
        		c0.4,0.1,0.9,0,1.3,0.1c0.2,0,0.5,0.2,0.7,0.3c0.8-0.3,0.8-0.3,2.6,0c0-0.2,0.1-0.3,0.1-0.5c0.4,0.1,0.7,0.1,1,0.2
        		c0.3,0.1,0.7,0.2,1.1,0.2c0,0,0-0.1-0.1-0.1c0.4,0,0.9,0,1.3-0.1c0.1,0.1,0.1,0.2,0.2,0.3c0.6-0.3,0.8-0.3,1.6-0.2
        		c0.1,0,0.3,0,0.3,0c0.1,0,0.1-0.1,0.2-0.1c0.3,0,0.6,0.1,0.9,0.3c0.2-0.1,0.4-0.1,0.5-0.1c0.3,0,0.7,0,0.7,0c0,0,0-0.1,0.1-0.1
        		c0.2,0.1,0.4,0.3,0.6,0.5c0.2-0.2,0.3-0.4,0.4-0.4c0.7,0.1,1.3,0.2,1.8,0.1c0.6-0.1,1.2-0.1,1.7,0.2c0.2,0.1,0.4,0.1,0.6,0.2
        		c0.1-0.2,0.1-0.4,0.2-0.6c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0c0.6,0.1,1.1,0.3,1.6,0.4c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0
        		c0.1,0,0.1,0,0.2-0.1c0.2-0.1,0.3-0.2,0.5-0.3c0.3,0.2,0.6,0.3,0.9,0.4c0.1-0.2,0.2-0.3,0.4-0.4c0.2-0.1,0.4-0.1,0.6-0.1
        		c0.3,0,0.5,0.3,0.6,0.3c0.2-0.1,0.4-0.1,0.6-0.2c0.3,0.1,0.5,0.1,0.9,0.2c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0,0
        		c0.5,0,1,0.1,1.5,0.1c0.4,0.2,0.7,0.2,1.1,0c0.7,0,1.5,0,2.2,0.2c0.2,0,0.5,0.1,0.6,0c0.2-0.1,0.4-0.2,0.5-0.2
        		c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.3-0.2c0.7,0,1.3,0.2,2,0.1c0.7,0.6,1.1,0.1,1.6-0.2c0.1,0,0.1,0,0.2,0
        		c0.5,0.4,1.1,0.6,1.7,0.3c0,0,0,0,0,0c0,0.1,0.2,0.1,0.3,0.2c0-0.1,0-0.2,0-0.3c0.1,0,0.3,0,0.4,0c0.4,0.1,0.7,0.1,1,0
        		c0.4,0,0.8,0.1,1.2,0.1c0.1-0.1,0.2-0.1,0.3-0.1c0.9-0.2,1.8,0.1,2.7,0.1c1.2,0,2.3-0.4,3.5-0.1c0.7-0.3,1.4,0,2,0.1
        		c0.2,0.1,0.7,0.1,0.7,0.1c0.6-0.7,1.2-0.1,1.7,0c1.1-0.4,1.2-0.4,1.3,0.4c0.3-0.3,0.5-0.5,0.8-0.8c0.7,0.6,1.8-0.1,2.5,0.5
        		c0.2-0.2,0.3-0.5,0.5-0.7c0.6,0.3,1,0.5,1.6,0.8c0.9-0.6,1.8,0,2.8-0.1c0-0.1,0-0.2,0-0.4c0.8-0.1,1.5,0,2,0.5
        		c0.5-0.1,0.8-0.7,1.5-0.4c0.9,0.4,1-0.2,1.4-0.4c0.4,0.3,0.8,0.9,1.6,0.2c0.2,0.2,0.4,0.4,0.6,0.6c0.5-0.2,0.8-0.3,1.1-0.4
        		c0.1,0.1,0.3,0.3,0.3,0.3c0.5-0.2,0.9-0.3,1.4-0.5c0.1,0.1,0.3,0.3,0.5,0.5c0.3-0.2,0.5-0.4,0.9-0.7c0.2,0.2,0.3,0.4,0.4,0.7
        		c0.8-0.5,1.7-0.6,2.4-0.4c1.1,0.3,2.1,0.2,3-0.1c0.5,0.1,1,0.1,1.3,0.2c0.6,0.2,0.7-0.4,1.2-0.2c0.2,0.2,0.4,0.3,0.7,0.5
        		c0.4-0.2,0.8-0.4,1.2-0.6c0.5,0.2,1.1,0.3,1.6,0.5c0.2-0.2,0.4-0.3,0.5-0.4c0.3,0,0.5,0.1,0.8,0.1c0.3,0,0.6,0,0.9,0.1
        		c0.6,0.1,1.3,0.4,1.7-0.2c0.7,0.3,1.6-0.1,2.3,0.3c0.3,0.2,0.6,0.2,0.7-0.1c0.1-0.3,0.4-0.3,0.7-0.3c0.2,0,0.4-0.2,0.6-0.3
        		c0.1,0.1,0.3,0.2,0.4,0.2c0.1,0.1,0.3,0.2,0.3,0.2c0.2-0.1,0.5-0.2,0.7-0.2c0.5,0,0.9,0.2,1.4,0.2c0.8,0.1,1.2-0.1,1.5-0.7
        		c0,0,0.2-0.1,0.4-0.1c0,0.3,0,0.6-0.1,0.9c0.4-0.1,0.7-0.1,1-0.2c0.2,0,0.6-0.1,0.7-0.1c0.2,0.1,0.3,0.3,0.5,0.6
        		c0.4-0.2,0.8-0.4,1.2-0.7c0.4,0.1,0.9,0.1,1.3,0.2c1.1,0.3,1.1,0.3,1.7-0.3c0.4,0.5,1.1,0.5,1.6,0.4c0.5-0.1,0.9-0.1,1.4-0.1
        		c0.6,0,1.2,0.1,1.8-0.1c0.4-0.1,0.7,0,1.1,0.1c0.6,0.2,0.9,0.1,1-0.3c1.2-0.3,2.2,0.5,3.4,0.5c-0.1-0.2-0.2-0.4-0.3-0.5
        		c0.9-0.2,1.4,0.1,1.7,0.6c0.6-0.3,0.8-0.3,1.6-0.2c0.1,0,0.3,0,0.3,0c0.5-0.4,0.9-0.2,1.4,0c0.2,0.1,0.8,0.1,0.9,0
        		c0.2-0.4,0.8-0.2,0.9-0.3c0.6-0.4,0.8,0.2,1.3,0.1c0.5-0.1,0.9-0.3,1.5,0.1c0.3,0.2,1.1,0,1.6,0c0.7-0.1,1.2,0.1,1.8,0.4
        		c0.1-0.2,0.3-0.3,0.4-0.5c0.4,0.2,0.8,0.4,1.2,0.6c0.4-0.7,1.2-0.6,1.9-0.4c0.3,0.1,0.7,0.1,1.1,0.2c-0.1-0.2-0.2-0.4-0.3-0.6
        		c0.6,0.1,1.2,0,1.4,0.2c0.6,0.5,1,0.3,1.7,0c0.6-0.2,1.5-0.3,2.2-0.2c0.4,0,0.7,0.3,1.1,0.5c0.6-0.4,1.2-0.6,1.6-0.5
        		c0.8,0.2,2.3,0.2,3,0.1c0.6-0.1,1,0,1.1,0.4c0,0.1,0.2,0.1,0.3,0.2c0-0.2,0-0.3,0-0.5c1,0.1,1.9,0.2,2.6,0.2c0,0,0.1,0,0.1-0.1
        		c0,0.2-0.1,0.3-0.1,0.5c0.1,0,0.2,0,0.2,0c0.4-0.1,0.6-0.3,0.8-1c0,0,0.1,0,0.1-0.1c0.3-0.2,0.8-0.4,0.9-0.7l-0.9-0.4
        		c0,0,0-0.1,0-0.1c0.1-0.2,0.3-0.5,0.2-0.6c-0.1-0.4,0-0.5,0.2-0.6c0.4-0.3,0.1-1.1,0.3-1.6c-0.6-0.7,0-1.3,0-2
        		c-0.1-0.4-0.2-0.9-0.2-1.2c0.3-1,0.2-2,0.1-3c0-0.7,0-1,0.4-1.4c-0.3-0.2-0.5-0.3-0.8-0.4c0.7-1.2,0.7-2.5,0.4-3.8
        		c0.1-0.3,0.3-0.5,0.4-0.7c-0.1-0.3-0.2-0.5-0.3-0.7c-0.1-0.2-0.1-0.4-0.2-0.9c0.2-0.1,0.3-0.3,0.3-0.3c-0.1-0.8-0.3-1.6-0.2-2.1
        		c0.2-1.1,0.1-2.1,0-3.1c-0.1-1.1-0.3-2.3,0.2-3c-0.1-0.5-0.2-0.9-0.1-1.3c0-0.4,0.1-0.8,0.2-1.2c-0.3-0.2-0.5-0.7-0.3-1.4
        		c0.1-0.4,0.2-0.9,0.2-1.3c0.1-0.7,0.1-1.3-0.3-1.6c0.2-0.6,0.3-1,0.5-1.5c-0.2-0.3-0.3-0.6-0.5-1c0.2-0.2,0.4-0.3,0.5-0.3
        		c0-0.6,0-1.2-0.4-1.1c0-0.4,0-0.8,0-1.2c0-0.3-0.1-0.6-0.1-0.9c0.1-0.8,0.4-1.5,0-2.2c0,0,0-0.2,0-0.3c0.2-0.5,0.1-1.2,0.1-1.7
        		c0-0.3,0.2-0.5,0.2-0.8c-0.3-0.9-0.3-0.9,0-3c-0.1,0-0.3-0.1-0.4-0.1c0.2-1.5,0.4-2.9,0.1-4.4c0.2-1.1-0.3-2.4,0.3-3.1
        		c-0.1-0.6-0.2-1-0.3-1.4c0.2-0.3,0.3-0.5,0.4-0.8c-0.2-0.2-0.3-0.4-0.4-0.4c0.1-0.8,0.2-1.5,0.1-2.1c-0.1-0.7-0.1-1.4,0.1-2
        		c0.1-0.2,0.1-0.5,0.2-0.7c-0.2-0.1-0.3-0.1-0.6-0.2c0.1-0.7,0.3-1.4,0.4-2.1c0-0.1,0-0.2-0.1-0.3c-0.1-0.4-0.3-0.7-0.4-1.1
        		c0.1-0.1,0.2-0.3,0.3-0.4c-0.1-0.5-0.2-0.9-0.2-1.3c0-0.3,0.2-0.6,0.3-0.7c-0.1-0.5-0.3-1-0.3-1.4c0.1-1.8,0-3.7,0.2-5.5
        		c0-0.2,0.1-0.6,0-0.7c-0.5-1.2,0.1-2.4-0.1-3.6c0.6-0.9,0.1-1.4-0.2-2c0.4-0.7,0.6-1.4,0.2-2.3c-0.1-0.1-0.1-0.4,0-0.6
        		c0.2-1-0.1-1.6-0.4-2.3c0.2-0.2,0.4-0.4,0.4-0.4c-0.2-1.1,0.1-2.2,0.1-3.2c0-1.4-0.3-2.7-0.1-4.1c-0.3-0.8,0-1.6,0.1-2.3
        		c0-0.3,0.1-0.8,0.1-0.8c-0.6-0.7-0.1-1.3,0-2C469.3,317.9,469.3,317.8,470,317.7z M468.8,302.6c-0.2,0.3-0.3,0.5-0.4,0.6
        		C468.3,302.6,468.4,302.5,468.8,302.6z M468.3,252c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1,0,0.1,0.1,0.2,0.2
        		C468.3,251.8,468.3,251.9,468.3,252z M468.5,229c0.4-0.2,0.4-0.2,0.4,0.6C468.7,229.4,468.6,229.2,468.5,229z M468.6,225
        		c0,0.1,0,0.2,0,0.4c-0.1,0-0.2,0-0.3,0c0,0,0-0.2,0-0.2C468.4,225,468.5,225,468.6,225z M468.2,216.4c-0.1-0.7,0-1,0.5-0.8
        		C468.5,216,468.4,216.2,468.2,216.4z M469.2,245.3c-0.1,0.1-0.1,0.2-0.2,0.3c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.3,0.1-0.4
        		C469.1,245,469.2,245.1,469.2,245.3z M469.2,220.2c-0.1,0.2-0.1,0.3-0.1,0.4c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0.1-0.2,0.1-0.3
        		C469,220,469.1,220.1,469.2,220.2z M469,123.8c-0.2-0.3-0.5-0.4-0.3-1.2C468.9,122.9,469.1,123.1,469,123.8z M468.8,95.6
        		c-0.2,0.3-0.3,0.5-0.4,0.6C468.3,95.7,468.4,95.5,468.8,95.6z M468.3,45c-0.1-0.1-0.1-0.2-0.2-0.3c0-0.1,0.1-0.2,0.1-0.2
        		c0.1,0,0.1,0.1,0.2,0.2C468.3,44.8,468.3,44.9,468.3,45z M469.2,38.3c-0.1,0.1-0.1,0.2-0.2,0.3c0-0.1-0.1-0.2-0.1-0.3
        		c0-0.1,0.1-0.3,0.1-0.4C469.1,38,469.2,38.1,469.2,38.3z M469,12.9c0.1,0.1,0.1,0.2,0.2,0.3c-0.1,0.2-0.1,0.3-0.1,0.4
        		c0-0.1-0.1-0.2-0.1-0.3C468.9,13.2,469,13,469,12.9z M468.8,22.7c-0.1-0.2-0.2-0.4-0.4-0.6C468.8,21.8,468.8,21.8,468.8,22.7z
        		 M468.3,18.4c0,0,0-0.2,0-0.2c0.1,0,0.2,0,0.3-0.1c0,0.1,0,0.2,0,0.4C468.5,18.4,468.4,18.4,468.3,18.4z M468.2,9.4
        		c-0.1-0.7,0-1,0.5-0.8C468.5,9,468.4,9.2,468.2,9.4z M391.3,1.2c-0.2,0.3-0.3,0.6-1,0.4C390.5,1.2,390.7,1,391.3,1.2z M366.9,1.3
        		c0.3,0.2,0.4,0.4,0.5,0.5C366.9,2,366.8,1.8,366.9,1.3z M322.8,2.2C322.8,2.2,322.8,2.2,322.8,2.2C322.7,2.2,322.7,2.2,322.8,2.2
        		C322.7,2.2,322.8,2.2,322.8,2.2z M315.5,2.4c0,0.1-0.2,0.1-0.2,0.1c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1
        		C315.3,2.3,315.4,2.3,315.5,2.4C315.5,2.3,315.6,2.3,315.5,2.4z M211.8,1.2c-0.1,0-0.1-0.1-0.2-0.1c0.1,0,0.2,0,0.3,0c0,0,0,0,0,0
        		C211.9,1.2,211.8,1.2,211.8,1.2z M143.4,2.2C143.4,2.2,143.4,2.2,143.4,2.2C143.4,2.2,143.3,2.2,143.4,2.2
        		C143.3,2.2,143.4,2.2,143.4,2.2z M136.2,2.4c0,0.1-0.2,0.1-0.2,0.1c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0-0.1
        		C135.9,2.3,136,2.3,136.2,2.4C136.1,2.3,136.2,2.3,136.2,2.4z M106.2,1.1c-0.2,0.1-0.5,0.3-0.6,0.4c0,0-0.1,0-0.1,0
        		C105.6,1.3,105.8,1.1,106.2,1.1z M82.1,1.3c0.3,0.2,0.4,0.4,0.5,0.5C82.1,2,82,1.8,82.1,1.3z M37.9,1.9C38,1.9,38.1,2,38.2,2
        		C38.1,2.1,38,2.2,38,2.2c-0.1-0.1-0.2-0.1-0.2-0.2C37.7,2,37.8,1.9,37.9,1.9z M32.4,0.9C32.5,1,32.6,1,32.7,1.1
        		c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.3-0.2C32.1,1,32.2,1,32.4,0.9z M30.6,2.1c0.1,0.1,0.2,0.2,0.1,0.3c0,0.1-0.2,0.1-0.2,0.1
        		c0-0.1-0.1-0.1-0.1-0.2C30.4,2.2,30.5,2.2,30.6,2.1z M18.8,1.4c-0.2,0.2-0.4,0.3-0.5,0.4C18.1,1.4,18.1,1.4,18.8,1.4z M15.1,1.6
        		c0,0.1,0,0.2,0,0.4c0,0-0.1,0-0.2,0c0-0.1,0-0.2-0.1-0.4C14.9,1.6,15,1.6,15.1,1.6z M10.6,1c0.1,0.1,0.2,0.1,0.3,0.2
        		c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2-0.1-0.3-0.1C10.4,1.1,10.5,1,10.6,1z M6.7,1.5C7,1.7,7.1,1.9,7.3,2C6.8,2.1,6.5,2.1,6.7,1.5z
        		 M1,89.2c0.2,0.3,0.5,0.4,0.3,1.2C1.1,90.2,0.9,89.9,1,89.2z M1.2,117.4c0.2-0.3,0.3-0.5,0.4-0.6C1.7,117.4,1.6,117.5,1.2,117.4z
        		 M1.7,168c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.1-0.1-0.2-0.2C1.7,168.2,1.7,168.1,1.7,168z M1.5,191
        		c-0.4,0.2-0.4,0.2-0.4-0.6C1.3,190.6,1.4,190.8,1.5,191z M1.4,195c0-0.1,0-0.2,0-0.4c0.1,0,0.2,0,0.3,0c0,0,0,0.2,0,0.2
        		C1.6,195,1.5,195,1.4,195z M1.8,203.6c0.1,0.7,0,1-0.5,0.8C1.5,204,1.6,203.8,1.8,203.6z M0.8,174.7c0.1-0.1,0.1-0.2,0.2-0.3
        		c0,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.3-0.1,0.4C0.9,175,0.8,174.9,0.8,174.7z M0.8,199.8c0.1-0.2,0.1-0.3,0.1-0.4
        		c0,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.2-0.1,0.3C1,200,0.9,199.9,0.8,199.8z M1,296.2c0.2,0.3,0.5,0.4,0.3,1.2
        		C1.1,297.1,0.9,296.9,1,296.2z M1.2,324.4c0.2-0.3,0.3-0.5,0.4-0.6C1.7,324.3,1.6,324.5,1.2,324.4z M1.7,375
        		c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1-0.1,0.2-0.1,0.2c-0.1,0-0.1-0.1-0.2-0.2C1.7,375.2,1.7,375.1,1.7,375z M0.8,381.7
        		c0.1-0.1,0.1-0.2,0.2-0.3c0,0.1,0.1,0.2,0.1,0.3c0,0.1-0.1,0.3-0.1,0.4C0.9,382,0.8,381.9,0.8,381.7z M1,407.1
        		c-0.1-0.1-0.1-0.2-0.2-0.3c0.1-0.2,0.1-0.3,0.1-0.4c0,0.1,0.1,0.2,0.1,0.3C1.1,406.8,1,407,1,407.1z M1.2,397.3
        		c0.1,0.2,0.2,0.4,0.4,0.6C1.2,398.2,1.2,398.2,1.2,397.3z M1.7,401.6c0,0,0,0.2,0,0.2c-0.1,0-0.2,0-0.3,0.1c0-0.1,0-0.2,0-0.4
        		C1.5,401.6,1.6,401.6,1.7,401.6z M1.3,411.4c0.2-0.4,0.3-0.6,0.5-0.8C1.8,411.2,1.8,411.6,1.3,411.4z M78.7,418.8
        		c0.2-0.3,0.3-0.6,1-0.4C79.5,418.8,79.3,419,78.7,418.8z M103.1,418.7c-0.3-0.2-0.4-0.4-0.5-0.5C103.1,418,103.2,418.2,103.1,418.7
        		z M147.2,417.8C147.2,417.8,147.2,417.8,147.2,417.8C147.3,417.8,147.3,417.8,147.2,417.8C147.3,417.8,147.2,417.8,147.2,417.8z
        		 M154.8,417.8c-0.1,0-0.2,0-0.3,0c0,0,0-0.1,0-0.1c0-0.1,0.2-0.1,0.2-0.1C154.8,417.6,154.8,417.6,154.8,417.8
        		C154.8,417.7,154.8,417.7,154.8,417.8z M258.1,418.8C258.1,418.8,258.1,418.8,258.1,418.8c0.1,0,0.1-0.1,0.1-0.1
        		c0.1,0,0.1,0.1,0.2,0.1C258.3,418.9,258.2,418.9,258.1,418.8z M326.6,417.8C326.6,417.8,326.6,417.8,326.6,417.8
        		C326.6,417.8,326.7,417.8,326.6,417.8C326.7,417.8,326.6,417.8,326.6,417.8z M334.2,417.8c-0.1,0-0.2,0-0.3,0c0,0,0-0.1,0-0.1
        		c0-0.1,0.2-0.1,0.2-0.1C334.1,417.6,334.2,417.6,334.2,417.8C334.2,417.7,334.2,417.7,334.2,417.8z M363.8,418.9
        		c0.2-0.1,0.5-0.3,0.6-0.4c0,0,0.1,0,0.1,0C364.4,418.7,364.2,418.9,363.8,418.9z M387.9,418.7c-0.3-0.2-0.4-0.4-0.5-0.5
        		C387.9,418,388,418.2,387.9,418.7z M432.1,418.1c-0.1,0-0.2-0.1-0.3-0.2c0.1-0.1,0.2-0.2,0.2-0.2c0.1,0.1,0.2,0.1,0.2,0.2
        		C432.3,418,432.2,418.1,432.1,418.1z M437.6,419.1c-0.1-0.1-0.2-0.2-0.3-0.2c0.1,0,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.3,0.2
        		C437.9,419,437.8,419,437.6,419.1z M439.4,417.9c-0.1-0.1-0.2-0.2-0.1-0.3c0-0.1,0.2-0.1,0.2-0.1c0,0.1,0.1,0.1,0.1,0.2
        		C439.6,417.8,439.5,417.8,439.4,417.9z M451.2,418.6c0.2-0.2,0.4-0.3,0.5-0.4C451.9,418.6,451.9,418.6,451.2,418.6z M454.9,418.4
        		c0-0.1,0-0.2,0-0.4c0,0,0.1,0,0.2,0c0,0.1,0,0.2,0.1,0.4C455.1,418.4,455,418.4,454.9,418.4z M459.4,419c-0.1-0.1-0.2-0.1-0.3-0.2
        		c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.3,0.1C459.6,418.9,459.5,419,459.4,419z M463.3,418.5c-0.3-0.3-0.5-0.4-0.7-0.6
        		C463.2,417.9,463.5,417.9,463.3,418.5z M1.8,383.7c0.1-0.1,0.2-0.2,0.2-0.2c0,0,0.1,0.2,0.1,0.3C2.1,383.9,2.1,384,2,384
        		C1.9,384,1.9,383.9,1.8,383.7z M1.8,176.8c0.1-0.1,0.2-0.2,0.2-0.2c0,0,0.1,0.2,0.1,0.3c-0.1,0.1-0.1,0.2-0.2,0.2
        		C1.9,177,1.9,176.9,1.8,176.8z M468.2,36.3c-0.1,0.1-0.2,0.2-0.2,0.2c0,0-0.1-0.2-0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.2
        		C468.1,36,468.1,36.1,468.2,36.3z M468.2,243.2c-0.1,0.1-0.2,0.2-0.2,0.2c0,0-0.1-0.2-0.1-0.3c0.1-0.1,0.1-0.2,0.2-0.2
        		C468.1,243,468.1,243.1,468.2,243.2z M469,330.8c-0.2-0.3-0.5-0.4-0.3-1.2C468.9,329.8,469.1,330.1,469,330.8z"
            />
            <path
                fill={color}
                d="M466.8,305.5c0.1-0.2,0.2-0.3,0.4-0.6C466.8,304.8,466.7,304.9,466.8,305.5z"
            />
            <path
                fill={color}
                d="M467.1,332.9c-0.2,0.8,0.1,0.9,0.3,1.2C467.5,333.4,467.4,333.1,467.1,332.9z"
            />
            <path
                fill={color}
                d="M466.6,230.4c-0.1,0-0.1,0.1-0.2,0.1c0,0.1,0,0.3,0.1,0.3c0.1,0,0.2,0,0.3-0.1
        		C466.7,230.5,466.7,230.4,466.6,230.4z"
            />
            <path
                fill={color}
                d="M466.9,228.7c0.1,0.2,0.2,0.4,0.4,0.6C467.2,228.4,467.2,228.4,466.9,228.7z"
            />
            <path
                fill={color}
                d="M467,224.5c-0.1,0-0.2,0.1-0.3,0.1c0,0.1,0,0.3,0,0.3c0.1,0,0.2,0,0.3,0C467,224.8,467,224.6,467,224.5z"
            />
            <path
                fill={color}
                d="M467.3,219.6c0,0.1,0.1,0.2,0.1,0.3c0-0.1,0.1-0.2,0.2-0.4c-0.1-0.1-0.1-0.2-0.2-0.3
        		C467.4,219.3,467.3,219.5,467.3,219.6z"
            />
            <path
                fill={color}
                d="M467.4,245.5c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.1-0.2,0.2-0.4c-0.1-0.2-0.1-0.3-0.2-0.4
        		C467.5,245.2,467.4,245.4,467.4,245.5z"
            />
            <path
                fill={color}
                d="M466.6,251.9c-0.1,0-0.1,0.2-0.2,0.3c0.1,0.1,0.1,0.2,0.2,0.3c0.1-0.1,0.1-0.2,0.1-0.4
        		C466.7,252.1,466.7,251.9,466.6,251.9z"
            />
            <path
                fill={color}
                d="M465.4,259.8c0,0.1,0.1,0.3,0.1,0.3c0.1,0,0.1-0.1,0.4-0.3c-0.2-0.2-0.3-0.3-0.4-0.3
        		C465.5,259.5,465.4,259.6,465.4,259.8z"
            />
            <path
                fill={color}
                d="M466.4,243.1c-0.1,0-0.1,0.1-0.2,0.2c0,0.1,0.1,0.3,0.1,0.3c0.1,0,0.1-0.1,0.3-0.2
        		C466.5,243.3,466.5,243.1,466.4,243.1z"
            />
            <path
                fill={color}
                d="M466.4,241.4c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0,0.1-0.2,0.2-0.2c-0.1-0.1-0.1-0.2-0.2-0.2
        		C466.6,241.1,466.5,241.3,466.4,241.4z"
            />
            <path
                fill={color}
                d="M465.7,245c-0.1-0.1-0.1-0.2-0.2-0.3c0,0.1-0.1,0.2-0.1,0.4c0,0.1,0.1,0.2,0.1,0.3
        		C465.6,245.3,465.6,245.2,465.7,245z"
            />
            <path
                fill={color}
                d="M385.4,416.3c0.1,0.1,0.3,0.2,0.5,0.5C386,416.3,385.9,416.2,385.4,416.3z"
            />
            <path
                fill={color}
                d="M360.6,417c0.6,0.1,0.9-0.1,1.1-0.4C361,416.4,360.9,416.8,360.6,417z"
            />
            <path
                fill={color}
                d="M450.2,416c0,0.1,0,0.2,0.1,0.4c0.2-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2
        		C450.3,415.9,450.2,415.9,450.2,416z"
            />
            <path
                fill={color}
                d="M451.5,416.8c0.8,0,0.8,0,0.6-0.5C451.8,416.5,451.7,416.7,451.5,416.8z"
            />
            <path
                fill={color}
                d="M455.3,416.2c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2-0.1-0.4C455.5,416.2,455.3,416.2,455.3,416.2z"
            />
            <path
                fill={color}
                d="M459.6,417.1c0.1,0,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
        		C459.8,416.9,459.7,417,459.6,417.1z"
            />
            <path
                fill={color}
                d="M437.1,417.1c0.1,0.1,0.2,0.2,0.3,0.2c0.2-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.2-0.4-0.2
        		C437.3,416.9,437.2,417,437.1,417.1z"
            />
            <path
                fill={color}
                d="M431.6,415.9c-0.1,0.1-0.1,0.1-0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C431.9,416,431.7,416,431.6,415.9z"
            />
            <path
                fill={color}
                d="M425.1,414.7c-0.1,0-0.3,0.1-0.3,0.1c0,0.1,0.1,0.2,0.3,0.4c0.2-0.3,0.3-0.4,0.3-0.4
        		C425.3,414.8,425.2,414.7,425.1,414.7z"
            />
            <path
                fill={color}
                d="M439.1,415.8c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.1-0.1-0.2
        		C439.3,415.7,439.1,415.7,439.1,415.8z"
            />
            <path
                fill={color}
                d="M441,415.8c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C441.2,416,441.1,416,441,415.8z"
            />
            <path
                fill={color}
                d="M437.5,414.8c0.1,0,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
        		C437.7,414.7,437.6,414.8,437.5,414.8z"
            />
            <path
                fill={color}
                d="M206,416.3c0.1,0.1,0.3,0.2,0.5,0.5C206.6,416.3,206.5,416.2,206,416.3z"
            />
            <path
                fill={color}
                d="M181.2,417c0.6,0.1,0.9-0.1,1.1-0.4C181.6,416.4,181.5,416.8,181.2,417z"
            />
            <path
                fill={color}
                d="M270.8,416c0,0.1,0,0.2,0.1,0.4c0.2-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2
        		C271,415.9,270.8,415.9,270.8,416z"
            />
            <path
                fill={color}
                d="M272.1,416.8c0.8,0,0.8,0,0.6-0.5C272.4,416.5,272.3,416.7,272.1,416.8z"
            />
            <path
                fill={color}
                d="M275.9,416.2c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2-0.1-0.4C276.1,416.2,275.9,416.2,275.9,416.2z"
            />
            <path
                fill={color}
                d="M257.7,417.1c0.1,0.1,0.2,0.2,0.3,0.2c0.2-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.2-0.4-0.2
        		C257.9,416.9,257.8,417,257.7,417.1z"
            />
            <path
                fill={color}
                d="M252.2,415.9c-0.1,0.1-0.1,0.1-0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C252.5,416,252.3,416,252.2,415.9z"
            />
            <path
                fill={color}
                d="M245.7,414.7c-0.1,0-0.3,0.1-0.3,0.1c0,0.1,0.1,0.2,0.3,0.4c0.2-0.3,0.3-0.4,0.3-0.4
        		C245.9,414.8,245.8,414.7,245.7,414.7z"
            />
            <path
                fill={color}
                d="M259.7,415.8c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.1-0.1-0.2
        		C259.9,415.7,259.7,415.7,259.7,415.8z"
            />
            <path
                fill={color}
                d="M261.6,415.8c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C261.8,416,261.7,416,261.6,415.8z"
            />
            <path
                fill={color}
                d="M258.1,414.8c0.1,0,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
        		C258.3,414.7,258.2,414.8,258.1,414.8z"
            />
            <path
                fill={color}
                d="M280,416.3c0.1,0.1,0.3,0.2,0.5,0.5C280.6,416.3,280.5,416.2,280,416.3z"
            />
            <path
                fill={color}
                d="M255.2,417c0.6,0.1,0.9-0.1,1.1-0.4C255.6,416.4,255.5,416.8,255.2,417z"
            />
            <path
                fill={color}
                d="M344.7,416c0,0.1,0,0.2,0.1,0.4c0.2-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2
        		C344.9,415.9,344.8,415.9,344.7,416z"
            />
            <path
                fill={color}
                d="M346,416.8c0.8,0,0.8,0,0.6-0.5C346.4,416.5,346.2,416.7,346,416.8z"
            />
            <path
                fill={color}
                d="M349.9,416.2c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2-0.1-0.4C350.1,416.2,349.9,416.2,349.9,416.2z"
            />
            <path
                fill={color}
                d="M354.2,417.1c0.1,0,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
        		C354.4,416.9,354.3,417,354.2,417.1z"
            />
            <path
                fill={color}
                d="M331.7,417.1c0.1,0.1,0.2,0.2,0.3,0.2c0.2-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.2-0.4-0.2
        		C331.9,416.9,331.8,417,331.7,417.1z"
            />
            <path
                fill={color}
                d="M326.2,415.9c-0.1,0.1-0.1,0.1-0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C326.4,416,326.3,416,326.2,415.9z"
            />
            <path
                fill={color}
                d="M319.7,414.7c-0.1,0-0.3,0.1-0.3,0.1c0,0.1,0.1,0.2,0.3,0.4c0.2-0.3,0.3-0.4,0.3-0.4
        		C319.9,414.8,319.8,414.7,319.7,414.7z"
            />
            <path
                fill={color}
                d="M333.7,415.8c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.1-0.1-0.2
        		C333.9,415.7,333.7,415.7,333.7,415.8z"
            />
            <path
                fill={color}
                d="M335.6,415.8c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C335.8,416,335.7,416,335.6,415.8z"
            />
            <path
                fill={color}
                d="M332.1,414.8c0.1,0,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
        		C332.3,414.7,332.2,414.8,332.1,414.8z"
            />
            <path
                fill={color}
                d="M100.6,416.3c0.1,0.1,0.3,0.2,0.5,0.5C101.2,416.3,101.1,416.2,100.6,416.3z"
            />
            <path
                fill={color}
                d="M75.8,417c0.6,0.1,0.9-0.1,1.1-0.4C76.2,416.4,76.1,416.8,75.8,417z"
            />
            <path
                fill={color}
                d="M165.4,416c0,0.1,0,0.2,0.1,0.4c0.2-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.2-0.1-0.2
        		C165.5,415.9,165.4,415.9,165.4,416z"
            />
            <path
                fill={color}
                d="M166.7,416.8c0.8,0,0.8,0,0.6-0.5C167,416.5,166.9,416.7,166.7,416.8z"
            />
            <path
                fill={color}
                d="M170.5,416.2c0,0.1,0,0.2,0,0.4c0.1,0,0.2,0,0.3,0c0-0.1,0-0.2-0.1-0.4C170.7,416.2,170.5,416.2,170.5,416.2z"
            />
            <path
                fill={color}
                d="M174.8,417.1c0.1,0,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
        		C175,416.9,174.9,417,174.8,417.1z"
            />
            <path
                fill={color}
                d="M152.3,417.1c0.1,0.1,0.2,0.2,0.3,0.2c0.2-0.1,0.2-0.1,0.3-0.2c-0.1-0.1-0.2-0.2-0.4-0.2
        		C152.5,416.9,152.4,417,152.3,417.1z"
            />
            <path
                fill={color}
                d="M146.8,415.9c-0.1,0.1-0.1,0.1-0.3,0.2c0.1,0.1,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C147.1,416,146.9,416,146.8,415.9z"
            />
            <path
                fill={color}
                d="M140.3,414.7c-0.1,0-0.3,0.1-0.3,0.1c0,0.1,0.1,0.2,0.3,0.4c0.2-0.3,0.3-0.4,0.3-0.4
        		C140.5,414.8,140.4,414.7,140.3,414.7z"
            />
            <path
                fill={color}
                d="M154.3,415.8c0,0.1,0.1,0.2,0.1,0.3c0.1-0.1,0.3-0.2,0.3-0.2c0-0.1-0.1-0.1-0.1-0.2
        		C154.5,415.7,154.3,415.7,154.3,415.8z"
            />
            <path
                fill={color}
                d="M156.2,415.8c-0.1,0.1-0.2,0.2-0.2,0.3c0,0.1,0.1,0.1,0.2,0.2c0.1-0.1,0.2-0.1,0.2-0.2
        		C156.4,416,156.3,416,156.2,415.8z"
            />
            <path
                fill={color}
                d="M152.7,414.8c0.1,0,0.2,0.1,0.3,0.2c0.1-0.1,0.2-0.1,0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1
        		C152.9,414.7,152.8,414.8,152.7,414.8z"
            />
            <path
                fill={color}
                d="M3.2,321.4c-0.1,0.2-0.2,0.3-0.4,0.6C3.2,322.2,3.3,322,3.2,321.4z"
            />
            <path
                fill={color}
                d="M2.6,292.9c-0.1,0.7,0.1,1,0.3,1.2C3.1,293.3,2.8,293.2,2.6,292.9z"
            />
            <path
                fill={color}
                d="M3.1,396.2c0.1,0.2,0.2,0.3,0.2,0.4c0.1,0,0.1-0.1,0.2-0.1c0-0.1,0-0.3-0.1-0.3C3.4,396.1,3.3,396.2,3.1,396.2
        		z"
            />
            <path fill={color} d="M2.7,397.6c0,0.9,0,0.9,0.4,0.6C3,398.1,2.9,397.9,2.7,397.6z" />
            <path
                fill={color}
                d="M3,402.1c0,0.1,0,0.3,0,0.4c0.1,0,0.2-0.1,0.3-0.1c0-0.1,0-0.3,0-0.3C3.2,402.1,3.1,402.1,3,402.1z"
            />
            <path
                fill={color}
                d="M2.4,407.5c0.1,0.1,0.1,0.2,0.2,0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.1-0.1-0.2-0.1-0.3
        		C2.5,407.2,2.5,407.3,2.4,407.5z"
            />
            <path
                fill={color}
                d="M2.6,381.4c0-0.1-0.1-0.2-0.1-0.3c-0.1,0.1-0.1,0.2-0.2,0.4c0.1,0.2,0.1,0.3,0.2,0.4
        		C2.5,381.7,2.6,381.6,2.6,381.4z"
            />
            <path
                fill={color}
                d="M3.2,374.8c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.2,0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3
        		C3.3,374.6,3.2,374.7,3.2,374.8z"
            />
            <path
                fill={color}
                d="M4.6,367.2c0-0.1-0.1-0.3-0.1-0.3c-0.1,0-0.1,0.1-0.4,0.3c0.2,0.2,0.3,0.3,0.4,0.3
        		C4.5,367.5,4.6,367.3,4.6,367.2z"
            />
            <path
                fill={color}
                d="M3.7,383.4c-0.1,0-0.1,0.1-0.3,0.2c0.1,0.1,0.1,0.3,0.2,0.3c0.1,0,0.1-0.1,0.2-0.2
        		C3.7,383.6,3.7,383.4,3.7,383.4z"
            />
            <path
                fill={color}
                d="M3.4,385.4c-0.1,0-0.1,0.2-0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.2-0.2
        		C3.5,385.5,3.4,385.3,3.4,385.4z"
            />
            <path
                fill={color}
                d="M4.3,382c0.1,0.1,0.1,0.2,0.2,0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.1-0.1-0.2-0.1-0.3C4.4,381.7,4.4,381.8,4.3,382z"
            />
            <path
                fill={color}
                d="M3.2,114.5c-0.1,0.2-0.2,0.3-0.4,0.6C3.2,115.2,3.3,115.1,3.2,114.5z"
            />
            <path fill={color} d="M2.6,85.9c-0.1,0.7,0.1,1,0.3,1.2C3.1,86.3,2.8,86.2,2.6,85.9z" />
            <path
                fill={color}
                d="M3.5,189.2c-0.1,0-0.2,0-0.3,0.1c0.1,0.2,0.2,0.3,0.2,0.4c0.1,0,0.1-0.1,0.2-0.1
        		C3.5,189.4,3.5,189.2,3.5,189.2z"
            />
            <path
                fill={color}
                d="M3.1,191.3c-0.1-0.2-0.2-0.4-0.4-0.6C2.8,191.6,2.8,191.6,3.1,191.3z"
            />
            <path
                fill={color}
                d="M3,195.5c0.1,0,0.2-0.1,0.3-0.1c0-0.1,0-0.3,0-0.3c-0.1,0-0.2,0-0.3,0C3,195.2,3,195.4,3,195.5z"
            />
            <path
                fill={color}
                d="M2.7,200.4c0-0.1-0.1-0.2-0.1-0.3c0,0.1-0.1,0.2-0.2,0.4c0.1,0.1,0.1,0.2,0.2,0.3
        		C2.6,200.7,2.7,200.5,2.7,200.4z"
            />
            <path
                fill={color}
                d="M2.6,174.5c0-0.1-0.1-0.2-0.1-0.3c-0.1,0.1-0.1,0.2-0.2,0.4c0.1,0.2,0.1,0.3,0.2,0.4
        		C2.5,174.8,2.6,174.6,2.6,174.5z"
            />
            <path
                fill={color}
                d="M3.4,168.1c0.1,0,0.1-0.2,0.2-0.3c-0.1-0.1-0.1-0.2-0.2-0.3c-0.1,0.1-0.1,0.2-0.1,0.4
        		C3.3,167.9,3.3,168.1,3.4,168.1z"
            />
            <path
                fill={color}
                d="M4.6,160.2c0-0.1-0.1-0.3-0.1-0.3c-0.1,0-0.1,0.1-0.4,0.3c0.2,0.2,0.3,0.3,0.4,0.3
        		C4.5,160.5,4.6,160.4,4.6,160.2z"
            />
            <path
                fill={color}
                d="M3.7,176.4c-0.1,0-0.1,0.1-0.3,0.2c0.1,0.1,0.1,0.3,0.2,0.3c0.1,0,0.1-0.1,0.2-0.2
        		C3.7,176.6,3.7,176.5,3.7,176.4z"
            />
            <path
                fill={color}
                d="M3.4,178.4c-0.1,0-0.1,0.2-0.2,0.2c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0,0.1-0.1,0.2-0.2
        		C3.5,178.5,3.4,178.4,3.4,178.4z"
            />
            <path
                fill={color}
                d="M4.3,175c0.1,0.1,0.1,0.2,0.2,0.3c0-0.1,0.1-0.2,0.1-0.4c0-0.1-0.1-0.2-0.1-0.3C4.4,174.7,4.4,174.8,4.3,175z"
            />
        </g>
    </svg>
);

Patch.propTypes = propTypes;
Patch.defaultProps = defaultProps;

export default Patch;
